import React, { Component } from 'react';
import { Loading } from '../components/Loading';
import ACHWarningPopUp from '../components/ACHWarningPopUp';
import Popup from 'reactjs-popup';
import { Col, Row, Button, Alert, Form, /*Dropdown*/ } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import StepZilla from 'react-stepzilla';
import ServiceCalls from '../utils/serviceCalls.js';
import RequestUtils from "../utils/requestUtils";
import CommonUtils from '../utils/siteUtils.js';
import { FileDrop } from 'react-file-drop'
import TimedDisplay from '../components/TimedDisplay';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan, faQuestion } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import * as ibantools from 'ibantools';
import '../styles/Vendor.css';
//Used to Validate EMEA+ suppliers that use IBAN and SWIFT BIC
//const ibantools = require('ibantools');


export class StepBank extends Component {
    constructor(props) {
        super(props);

        this.state = {
            taxIdNumber: props.getStore().taxIdNumber,
            bankName: props.getStore().bankName,
            bankAddress: props.getStore().bankAddress,
            bankRoutingNumber: props.getStore().bankRoutingNumber,
            bankCity: props.getStore().bankCity,
            bankAccountNumber: props.getStore().bankAccountNumber,
            bankState: props.getStore().bankState,
            bankPostal: props.getStore().bankPostal,
            bankCountry: props.getStore().bankCountry,
            bankSignatory: props.getStore().bankSignatory,
            isBankSig: (props.getStore().bankSignatory) ? (props.getStore().bankSignatory === "YES") : false,
            bankSigSet: (props.getStore().bankSignatory),
            isValidated: false,
            hasValidTIN: (this.props.vendorData.taxIdNumber === props.getStore().taxIdNumber),
            stateList: props.getStore().stateList,
            isLoading: true,
            isStateDDOpen: false,
            hasValidated: false,
            hasValidRoutingNumber: RequestUtils.validateRoutingNumber(props.getStore().bankRoutingNumber),
            hasValidBankNumber: props.getStore().bankAccountNumber !== "",
            hasRNValidated: false,
            hasBAValidated: false
        };

        this._validateOnDemand = false; // this flag enables onBlur validation as user fills forms
        this.onBankSigClick = this.onBankSigClick.bind(this);
        this.validationCheck = this.validationCheck.bind(this);
        this.isValidated = this.isValidated.bind(this);
        this.validateTIN = this.validateTIN.bind(this);

        this.validateRoutingNumber = this.validateRoutingNumber.bind(this);
        this.validateAccountNumber = this.validateAccountNumber.bind(this);
        this.trimTIN = this.trimTIN.bind(this);
        this.trimRoutingNumber = this.trimRoutingNumber.bind(this);
        this.trimAccountNumber = this.trimAccountNumber.bind(this);
        this.onStateDDClick = this.onStateDDClick.bind(this);
    }
    componentDidMount() {

        if (this.state.stateList.length === 0 && this.props.editMode !== "REMOVE") {
            var defCountry = "USA";
            ServiceCalls.getVendorRegions(defCountry).then(function (data) {
                console.log(`In getRegions with a value of ${defCountry} - fetch complete with ${data.length} results`);
                if (data) {

                    data.sort(function (a, b) { return (a.region > b.region ? 1 : (a.region === b.region ? 0 : -1)) });
                    this.setState(
                        {
                            stateList: data,
                            isLoading: false
                        }
                    );
                }
                else {
                    console.log(`Error fetching Regions`);
                    this.setState(
                        {
                            isLoading: false,
                        });
                }
            }.bind(this));
        }
        else {
            this.setState(
                {
                    isLoading: false,

                });
        }
    }
    componentWillUnmount() {
        try {
            const userInput = this._grabUserInput();
            this.props.updateStore({
                ...userInput,
                savedToCloud: false // use this to notify step4 that some changes took place and prompt the user to save again
            });
        } catch (e) {
            //quietly handle dismount
        }
    }

    isValidated() {
        const userInput = this._grabUserInput(); // grab user entered vals
        const validateNewInput = this._validateData(userInput); // run the new input against the validator
        let isDataValid = false;

        // if full validation passes then save to store and pass as valid
        if (Object.keys(validateNewInput).every((k) => { return validateNewInput[k] === true }) &&
            this.state.bankSigSet) {
            if (this.props.getStore().bankName !== userInput.bankName
                || this.props.getStore().bankAddress !== userInput.bankAddress
                || this.props.getStore().bankRoutingNumber !== userInput.bankRoutingNumber
                || this.props.getStore().bankCity !== userInput.bankCity
                || this.props.getStore().bankAccountNumber !== userInput.bankAccountNumber
                || this.props.getStore().bankState !== userInput.bankState
                || this.props.getStore().bankPostal !== userInput.bankPostal
                || this.props.getStore().bankSignatory !== userInput.bankSignatory
                || this.props.getStore().stateList.length !== this.state.stateList.length) { // only update store of something changed
                this.props.updateStore({
                    ...userInput,
                    savedToCloud: false // use this to notify step4 that some changes took place and prompt the user to save again
                });  // Update store here (this is just an example, in reality you will do it via redux or flux)

            }
            isDataValid = true;
        }
        else {
            // if anything fails then update the UI validation state but NOT the UI Data State
            /*var form = document.querySelector("#bankForm");*/
            var currentValidRtrNum = RequestUtils.validateRoutingNumber(userInput.bankRoutingNumber);
            var routingValid = (currentValidRtrNum && userInput.bankRoutingNumber !== "") || (currentValidRtrNum === false && userInput.bankRoutingNumber === "");
            var baValid = (userInput.bankAccountNumber !== "") || (this.state.hasValidBankNumber === false && userInput.bankAccountNumber === "");
            var isValid = (this.state.hasValidTIN) && (routingValid) && (baValid);
            this.setState({
                isValidated: isValid,
                hasValidated: true
            });
        }
        return isDataValid;
    }

    validationCheck() {
        if (!this._validateOnDemand)
            return;

        const userInput = this._grabUserInput(); // grab user entered vals
        const validateNewInput = this._validateData(userInput); // run the new input against the validator

        this.setState(Object.assign(userInput, validateNewInput, this._validationErrors(validateNewInput)));
    }
    validateTIN() {
        //2-7 Do not allow empty source TINs
        var isValid = (this.props.vendorData.taxIdNumber.trim()!=='' && this.refs.taxIdNumber.value === this.props.vendorData.taxIdNumber);

        this.setState({
            hasValidTIN: isValid,
            taxIdNumber: this.refs.taxIdNumber.value,
            hasValidated: true
        });
    }
    validateRoutingNumber() {
        var isValid = RequestUtils.validateRoutingNumber(this.refs.bankRoutingNumber.value);
        this.setState({
            hasValidRoutingNumber: isValid,
            bankRoutingNumber: (isValid === true) ? this.refs.bankRoutingNumber.value : "",
            hasRNValidated: true,
            isValidated: false
        });
    }
    validateAccountNumber() {
        var isValid = this.refs.bankAccountNumber.value!=="" ;
        this.setState({
            hasValidBankNumber: isValid,
            bankAccountNumber: (isValid === true) ? this.refs.bankAccountNumber.value : "",
            hasBAValidated: true,
            isValidated: false
        });
    }
    trimTIN() {
        var v1 = this.refs.taxIdNumber.value.replace(/[-/\\\s]/g, '');
        this.refs.taxIdNumber.value = v1;
    }
    trimRoutingNumber(){
        var v2 = this.refs.bankRoutingNumber.value.replace(/[-/\\\s]/g, '');        
        this.refs.bankRoutingNumber.value = v2;
    }
    trimAccountNumber() {
        //Only Allow Numbers
        var v3 = this.refs.bankAccountNumber.value.replace(/\D+/g, '');
        this.refs.bankAccountNumber.value = v3;
    }
    _validateData(data) {
        return {
            bankName: data.bankName !== "", // required: anything besides N/A
            taxIdNumber: data.taxIdNumber === this.props.vendorData.taxIdNumber,
            bankRoutingNumber: data.bankRoutingNumber !== "" && this.state.hasValidRoutingNumber,
            bankAccountNumber: data.bankAccountNumber !== "",
            bankSignatory: data.bankSignatory !== ""
        }
    }

    _validationErrors(val) {
        const errMsgs = {
            emailValMsg: val.emailVal ? '' : 'A valid email is required'
        }
        return errMsgs;
    }
    _grabUserInput() {
        try {
            return {
                taxIdNumber: this.refs.taxIdNumber.value,
                bankName: this.refs.bankName.value,
                bankAddress: this.refs.bankAddress.value,
                bankRoutingNumber: this.refs.bankRoutingNumber.value,
                bankCity: this.refs.bankCity.value,
                bankAccountNumber: this.refs.bankAccountNumber.value,
                bankState: this.refs.bankState.value,
                bankPostal: this.refs.bankPostal.value,
                bankCountry: this.refs.bankCountry.value,
                bankSignatory: this.state.bankSignatory,
                stateList: this.state.stateList
            };
        } catch (e) {
            console.log(`Error validating bank data Ex: ${e}`);
            return {};
        }

    }
    onStateDDClick() {
        this.setState({ isStateDDOpen: !this.state.isStateDDOpen });
    }
    onBankSigClick = ({ target: { value } }) => {
        this.setState({
            isBankSig: (value === "YES"),
            bankSigSet: true,
            bankSignatory: value
        });
    }
    render() {
        const { editMode, currentBank, vendorData } = this.props;
        
        const { isLoading, stateList, hasValidRoutingNumber, hasValidTIN, hasRNValidated, hasValidBankNumber, hasBAValidated } = this.state;
        var isRTRNumberInvalid = (hasValidRoutingNumber === false) && hasValidTIN && hasRNValidated;
        var stepTitle = (editMode === "ADD") ? "Authorization for ACH Payments" : "Request Bank Change";

        var isEMEASupplier = CommonUtils.determineIfVendorIsEMEAPlus(vendorData);
        var stateInput = (editMode !== 'REMOVE' && stateList.length > 0)
            ? <Form.Select disabled={(this.state.hasValidTIN === false)}
                placeholder="State"
                defaultValue={this.state.bankState}
                onChange={this.validationCheck}
                tabIndex="3"
                ref="bankState">
                <option key="0">State</option>
                {
                    this.state.stateList.map(st => (
                        <option key={st.region} value={st.region}>{st.region}</option>
                    ))
                }
            </Form.Select>
            : <Form.Control
                ref="bankState"
                type="text"
                required
                defaultValue={this.state.bankState}
                onBlur={this.validationCheck}
                readOnly={(this.state.hasValidTIN === false)}
                maxLength="6"
                placeholder="State"
                tabIndex="3"
            />;
        const currentPaymentMethod = (vendorData.vendorPayments.length > 0) ? vendorData.vendorPayments[0].paymentMethod : '';
        const bankValue = (currentBank.beneficiaryBank) ? currentBank.beneficiaryBank : <span>&nbsp;</span>;
        const accountValue = (currentBank.bankAccountNumber) ? currentBank.bankAccountNumber : <span>&nbsp;</span>;
        const dfiValue = (currentBank.dfiNumber) ? currentBank.dfiNumber : <span>&nbsp;</span>;
        var removeDisplay = (editMode === "ADD")
            ? <Col sm={5}><div className="validateMsg"><strong>Validate Supplier Tax ID Number:</strong></div></Col>
            : <Col sm={6}>
                <div>
                    <strong>Remove:</strong>
                </div>

                <div>
                    <div className="bankDataHdr">Bank Name</div>
                    <div>{bankValue}</div>
                </div>
                <div>
                    <div className="bankDataHdr">{CommonUtils.determineVendorBankNumberLabel("USA", currentPaymentMethod,currentBank.dfiQualifier)}</div>
                    <div>{accountValue}</div>
                </div>
                <div>
                    <div className="bankDataHdr">{CommonUtils.determineVendorBankRoutingLabel(currentBank.dfiQualifier)}</div>
                    <div>{dfiValue}</div>
                </div>
     
            </Col>;
        var removeEMEADisplay = (editMode !== "ADD" && isEMEASupplier)
            ? <Col sm={6}>
                <div>
                    &nbsp;
                </div>

                <div>
                    <div className="bankDataHdr">Bank Country</div>
                    <div>{currentBank.country}</div>
                </div>
                <div>
                    <div className="bankDataHdr">{CommonUtils.determineEMEABankIDLabel(currentBank.country)}</div>
                    <div> {CommonUtils.determineEMEABankIDValue(currentBank.country)}:</div>
                </div>
                <div>
                    <div className="bankDataHdr">Intermediary Swift</div>
                    <div> {(currentBank.intermediarySwiftId) ? currentBank.intermediarySwiftId : ""}</div>
                </div>      
            </Col>
            : <Col sm={6}>
                <Form.Group as={Col} controlId="taxIdNumber">
                    <Form.Label><div className="bankDataHdr">Supplier Tax ID</div>
                        <span className="required">*</span></Form.Label>
                    <OverlayTrigger
                        overlay={<Tooltip>Must be a 9-digit number, no hyphens or spaces.</Tooltip>}>
                        <span>
                            <FontAwesomeIcon id="fa-tinHelper" size="xs" className="fa-regular bankRequestHelpText" icon={faQuestion} />
                        </span>
                    </OverlayTrigger>
                    <Form.Control
                        ref="taxIdNumber"
                        type="text"
                        defaultValue={this.state.taxIdNumber}
                        onBlur={this.validateTIN}
                        maxLength="9"
                        isInvalid={(this.state.hasValidTIN === false) && this.state.hasValidated}
                        onChange={this.trimTIN}
                        placeholder="Supplier Tax ID"
                        tabIndex="1"
                        autoFocus={true}
                    />
                    <Form.Control.Feedback type="invalid" className="helperText">
                        Tax ID does not match our records, please select Supplier Inquiry in the Contact Us page for assistance.
                    </Form.Control.Feedback>
                </Form.Group>
            </Col>

        return (
            <div className="eftStep">
                {
                    (isLoading)
                        ? <div className="loadingForm"><h5> Loading Form ...</h5><br /><Loading /></div>
                        : <Form id="bankForm" noValidate validated={this.state.isValidated} className="form-horizontal">
                            <Row className="eftStepHdrRow">
                                <Col sm={12} className="eftStepHdrText">
                                    {stepTitle}
                                </Col>
                            </Row>
                            <Row className="tinArea">
                                {removeDisplay}
                                {removeEMEADisplay}
                            </Row>
                            {(editMode === "UPDATE")
                                ? <Row>
                                    <Col sm={12}>
                                        <strong>Replace:</strong>
                                    </Col>
                                </Row>
                                : <></>}
                            <Row className="eftStepHdrRow">
                                <Col sm={12} className="eftStepHdrText">
                                    Depository Bank
                                </Col>
                            </Row>
                            <div className="formSection">
                                <Row className="eftStepRow">
                                    <Form.Group as={Col} sm={6} controlId="bankName">
                                        <Form.Label>Bank Name <span className="required">*</span></Form.Label>
                                        <Form.Control
                                            ref="bankName"
                                            type="text"
                                            required
                                            defaultValue={this.state.bankName}
                                            onBlur={this.validationCheck}
                                            readOnly={(this.state.hasValidTIN === false)}
                                            maxLength="30"
                                            placeholder="Bank Name"
                                            tabIndex="2"
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} sm={6} controlId="bankAddress">
                                        <Form.Label>Bank Address</Form.Label>
                                        <Form.Control
                                            ref="bankAddress"
                                            type="text"
                                            defaultValue={this.state.bankAddress}
                                            onBlur={this.validationCheck}
                                            readOnly={(this.state.hasValidTIN === false)}
                                            maxLength="110"
                                            placeholder="Bank Address"
                                            tabIndex="3"
                                        />
                                    </Form.Group>
                                </Row>
                                <Row className="eftStepRow">
                                    <Form.Group as={Col} sm={6} controlId="bankRoutingNumber">
                                        <Form.Label>Routing Number
                                            <span className="required">*</span>
                                            <OverlayTrigger
                                                overlay={<Tooltip>Must be a 9-digit number, no hyphens or spaces.</Tooltip>}>
                                                <span>
                                                    <FontAwesomeIcon id="fa-rtHelper" size="xs" className="fa-regular bankRequestHelpText" icon={faQuestion} />
                                                </span>
                                            </OverlayTrigger>
                                        </Form.Label>
                                        <Form.Control
                                            ref="bankRoutingNumber"
                                            type="text"
                                            defaultValue={this.state.bankRoutingNumber}
                                            onChange={this.trimRoutingNumber}
                                            isInvalid={isRTRNumberInvalid}
                                            onBlur={this.validateRoutingNumber}
                                            readOnly={(this.state.hasValidTIN === false)}
                                            required={(this.state.hasValidRoutingNumber === false) || (this.state.bankRoutingNumber === "")}
                                            maxLength="9"
                                            placeholder="Routing Number"
                                            tabIndex="2"
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} sm={6} controlId="bankCity">
                                        <Form.Label>City</Form.Label>
                                        <Form.Control
                                            ref="bankCity"
                                            type="text"
                                            readOnly={(this.state.hasValidTIN === false)}
                                            defaultValue={this.state.bankCity}
                                            onBlur={this.validationCheck}
                                            maxLength="30"
                                            placeholder="City"
                                            tabIndex="3"
                                        />
                                    </Form.Group>
                                </Row>
                                <Row className="eftStepRow">
                                    <Form.Group as={Col} sm={6} controlId="bankAccountNumber">
                                        <Form.Label>Accout Number
                                            <span className="required">*</span>
                                            <OverlayTrigger
                                                overlay={<Tooltip>Must be a number, no hyphens or spaces.</Tooltip>}>  
                                                <span>
                                                    <FontAwesomeIcon id="fa-baHelper" size="xs" className="fa-regular bankRequestHelpText" icon={faQuestion} />
                                                </span>
                                            </OverlayTrigger>
                                        </Form.Label>
                                        <Form.Control
                                            ref="bankAccountNumber"
                                            type="text"
                                            readOnly={(this.state.hasValidTIN === false)}
                                            onChange={this.trimAccountNumber}
                                            defaultValue={this.state.bankAccountNumber}
                                            onBlur={this.validateAccountNumber}
                                            required
                                            maxLength="35"
                                            placeholder="Acccout Number"
                                            tabIndex="2"
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} sm={2} controlId="bankState">
                                        <Form.Label>State</Form.Label>
                                        {stateInput}
                                    </Form.Group>
                                    <Form.Group as={Col} sm={2} controlId="bankPostalCode">
                                        <Form.Label>Postal</Form.Label>
                                        <Form.Control
                                            ref="bankPostal"
                                            type="text"
                                            defaultValue={this.state.bankPostal}
                                            onBlur={this.validationCheck}
                                            readOnly={(this.state.hasValidTIN === false)}
                                            maxLength="12"
                                            placeholder="Postal Code"
                                            tabIndex="3"
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} sm={2} controlId="bankCountry">
                                        <Form.Label>Country</Form.Label>
                                        <Form.Control
                                            ref="bankCountry"
                                            type="text"
                                            defaultValue={this.state.bankCountry}
                                            readOnly={true}
                                            tabIndex="3"
                                        />
                                    </Form.Group>
                                </Row>
                                {/*<Row>*/}
                                {/*    <Col sm={12}>*/}
                                {/*        {(hasValidBankNumber === false && hasBAValidated===true)*/}
                                {/*            ?*/}
                                {/*            <div className="errorHelperText">*/}
                                {/*                The bank account number is not valid, please enter a valid bank account number or select Supplier Inquiry in the Contact Us page for assistance.*/}
                                {/*            </div>*/}
                                {/*            : <>*/}
                                {/*              </>*/}
                                {/*        }*/}
                                {/*    </Col>*/}
                                {/*</Row>*/}
                            <Row>
                                <Form.Group as={Col} sm={6} className="sigRadios">
                                    <Form.Label>Are you account signatory or authorized delegate?<span className="required">*</span></Form.Label>
                                    <br />
                                    <Form.Check
                                        inline={true}
                                        label="Yes"
                                        value="YES"
                                        name="bankSignatory"
                                        onChange={this.onBankSigClick}
                                        required={true}
                                        disabled={(this.state.hasValidTIN === false)}
                                        type="radio"
                                        checked={(this.state.bankSigSet !== '') ? (this.state.isBankSig === true) : false}
                                            id="bankSignatoryYes"
                                            tabIndex="4"

                                        />
                                        <Form.Check
                                            inline={true}
                                            label="No"
                                            value="NO"
                                            checked={(this.state.bankSigSet !== '') ? (this.state.isBankSig === false) : false}
                                            disabled={(this.state.hasValidTIN === false)}
                                            name="bankSignatory"
                                            required={true}
                                            type="radio"
                                            id="bankSignatoryNo"
                                            onChange={this.onBankSigClick}
                                            tabIndex="4"
                                    />
                                </Form.Group>
                                <Col sm={6}>
                                    <div className="helperText sigRadios">If an ACH payment location is needed outside of USA, please select Supplier Inquiry in the Contact Us page for assistance.</div>
                                </Col>
                            </Row>
                            <Row className="formBottomRow">
                                <Col sm={12}>
                                        {(this.state.isValidated) ? (this.state.bankSigSet && hasValidRoutingNumber && hasValidTIN && hasValidBankNumber && this.state.bankName!="") ? <></> : <Col className="error" sm={5}>Make sure all required fields are populated</Col> : <></>}
                                </Col>
                            </Row>
                        </div>
                    </Form>
                }
            </div>
        )
    }
}
export class StepEMEABank extends Component {
    constructor(props) {
        super(props);

        this.state = {       
            bankName: "", //props.getStore().bankName"",          
            bankRoutingNumber: props.getStore().bankRoutingNumber,    //SWIFT CODE        
            bankAccountNumber: props.getStore().bankAccountNumber,
            bankEMEAIBAN: props.getStore().bankEMEAIBAN,
            bankEMEASortCode: props.getStore().bankEMEASortCode,
            bankEMEAIntermediarySwift: props.getStore().bankEMEAIntermediarySwift,
            bankEMEABranchId: props.getStore().bankEMEABranchId,
            bankCountry: props.getStore().bankCountry,
            emeaBankDisplay:[],
            isValidated: false,
            hasValidated:false,
            isIBANInvalid: false,
            isSwiftInvalid: false,
            isInterSwiftInvalid:false,
            isCountryDDOpen: false,
            isCountryIBANEnabled: (props.getStore().bankCountry.countryIBANValidation && props.getStore().bankCountry.countryIBANValidation.ibanEnterable === "Y"),
            extractedIBANParts: {
                countryCode: null,
                ibanCheckDigit:null,
                bankAccountNumber: null,
                bankId: null,
                branchId: null,
                checkDigit: null,
                dfiIdNumber: null
            },
            ibanExtracted:false,
            validatedElements: {},
            isFormValid: true,
            isLoading: true,            
            countryList: props.getStore().countryList,
            hasValidRoutingNumber: RequestUtils.validateRoutingNumber(props.getStore().bankRoutingNumber),
            hasValidBankNumber: props.getStore().bankAccountNumber !== ""

        };

        this._validateOnDemand = false; // this flag enables onBlur validation as user fills forms
       
        this.validationCheck = this.validationCheck.bind(this);
        this.isValidated = this.isValidated.bind(this);
        this.validateIBAN = this.validateIBAN.bind(this);
        this.validateAccountNumber = this.validateAccountNumber.bind(this);
        this.validateSwiftBic = this.validateSwiftBic.bind(this);
        this.validateSortCode = this.validateSortCode.bind(this);
        this.trimIBAN = this.trimIBAN.bind(this);
        this.trimSwiftBic = this.trimSwiftBic.bind(this);
        this.trimAccountNumber = this.trimAccountNumber.bind(this);
        this.trimSortCode = this.trimSortCode.bind(this);
        this.trimIntermediarySwift = this.trimIntermediarySwift.bind(this);
        this.trimBranchId = this.trimBranchId.bind(this);
        this.onCountryDDClick = this.onCountryDDClick.bind(this);
        this.onCountryNameChange = this.onCountryNameChange.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.buildEMEABranchIdFormControl = this.buildEMEABranchIdFormControl.bind(this);
        this.buildEMEASwiftCodeFormControl = this.buildEMEASwiftCodeFormControl.bind(this);
        this.regExFilter = /[^a-zA-Z0-9]/g;
    }

    componentDidMount() {
        const { vendorData } = this.props;
        if (this.state.countryList.length === 0 && this.props.editMode !== "REMOVE") {
            var defCountry = (vendorData.vendorBanks.length > 0) ? vendorData.vendorBanks[0].country : "";
            this.getCountries(defCountry);            
        }
        else {
            this.setState(
                {
                    isLoading: false,

                });
        }
    }
    componentWillUnmount() {
        try {
            const userInput = this._grabUserInput();
            this.props.updateStore({
                ...userInput,
                savedToCloud: false // use this to notify step4 that some changes took place and prompt the user to save again
            });
        } catch (e) {
            //quietly handle dismount
        }
    }

    _validateData(data) {
        if (data.bankCountry) {
            const { vendorData, currentBank } = this.props;
            const { extractedIBANParts, bankCountry,ibanExtracted, isCountryIBANEnabled } = this.state;

            const currentPaymentMethod = (vendorData.vendorPayments.length > 0) ? vendorData.vendorPayments[0].paymentMethod : '';
            const currentdfiQualifer = currentBank.dfiQualifier;
            var isSwiftValid = !this.state.isSwiftInvalid;
            var isIBANValid = !this.state.isIBANInvalid;
            var isImdSwiftValid = !this.state.isInterSwiftInvalid;
            switch (data.bankCountry.country) {
                case "AUS":
                    isImdSwiftValid = this.validateSwiftBic(1, false);
                    if (currentPaymentMethod === 'ACH') {
                        isSwiftValid = this.validateSwiftBic(0, true);  
                        return {
                            bankAccountNumber: (data.bankAccountNumber !== "" && (!(ibanExtracted) || extractedIBANParts.bankAccountNumber === data.bankAccountNumber)),
                            bankEMEASortCode: (data.bankEMEASortCode !== "" && data.bankEMEASortCode.length === 3 && (!(ibanExtracted) || (extractedIBANParts.bankId && extractedIBANParts.bankId.toUpperCase() === data.bankEMEASortCode.toUpperCase()))),//DE981453
                            bankEMEABranchId: (data.bankEMEABranchId !== "" && data.bankEMEABranchId.length === 3 && (!(ibanExtracted) || extractedIBANParts.branchId === data.bankEMEABranchId)), //DE981453
                            bankEMEAIntermediarySwift:isImdSwiftValid
                        }
                    }
                    else if (currentPaymentMethod === 'WIR') {     
                        //US7607181 - if WIR and BP use AUS domestic template - Else use International WIR template
                        if (currentdfiQualifer === 'BP') {
                            isSwiftValid = this.validateSwiftBic(2, true);
                        }
                        else {
                            isSwiftValid = this.validateSwiftBic(0, true);
                        }
        
                        return {
                            bankAccountNumber: (data.bankAccountNumber !== "" && (!(ibanExtracted) || extractedIBANParts.bankAccountNumber === data.bankAccountNumber)),
                            bankRoutingNumber: (data.bankRoutingNumber !== "" && isSwiftValid),
                            bankEMEAIntermediarySwift: isImdSwiftValid
                        }
                    }
                    else {
                        return {
                            bankAccountNumber: false,                            
                        }
                    }
                case "IND":
                    //DE1134191 For India, Branch ID is NOT required
                    return {
                        bankAccountNumber: (data.bankAccountNumber !== ""),
                        bankEMEAIntermediarySwift: (data.bankEMEAIntermediarySwift === "" || ibantools.validateBIC(data.bankEMEAIntermediarySwift).valid),
                        bankRoutingNumber: (data.bankRoutingNumber !== "" && this.validateSwiftBic(0, true))
                    }
                case "GBR":
                    //UK
                    isSwiftValid = this.validateSwiftBic(0, (currentPaymentMethod === 'WIR' || (currentPaymentMethod === 'ACH' && data.bankEMEAIBAN!=="")));
                    isImdSwiftValid = this.validateSwiftBic(1, false);

                    if (currentPaymentMethod === 'ACH') {
                        return {
                            bankAccountNumber: (data.bankAccountNumber !== "" && (!(ibanExtracted) || extractedIBANParts.bankAccountNumber === data.bankAccountNumber)),
                            bankEMEASortCode: (data.bankEMEASortCode !== "" && (!(ibanExtracted) || (extractedIBANParts.bankId && extractedIBANParts.bankId.toUpperCase() === data.bankEMEASortCode.toUpperCase()))),
                            bankEMEAIBAN: isIBANValid,
                            bankRoutingNumber: (isSwiftValid) ? true : (data.bankEMEAIBAN) ? (data.bankRoutingNumber !== "" && isSwiftValid) : isSwiftValid,
                            bankEMEAIntermediarySwift: isImdSwiftValid
                        }
                    }
                    else if (currentPaymentMethod === 'WIR') {
                        return {
                            bankEMEAIBAN: isIBANValid,  //DE1002655
                            bankAccountNumber: (data.bankAccountNumber !== "" && (!(ibanExtracted) || extractedIBANParts.bankAccountNumber === data.bankAccountNumber)),
                            bankRoutingNumber: (isSwiftValid) ? true : (data.bankRoutingNumber !== "" && isSwiftValid),
                            bankEMEAIntermediarySwift: isImdSwiftValid,
                            bankEMEASortCode: (data.bankEMEAIBAN !== "") ? (data.bankEMEASortCode !== "" && (!(ibanExtracted) || (extractedIBANParts.bankId && extractedIBANParts.bankId.toUpperCase() === data.bankEMEASortCode.toUpperCase()))) : true  //DE1002655
                        }
                    }
                    else {
                        return {
                            bankAccountNumber: false,
                        }
                    }
                case "IRL":
                    //Get latest status of IBAN
                    isIBANValid = this.validateIBAN(true);
                    isSwiftValid = this.validateSwiftBic(0, true);
                    isImdSwiftValid = this.validateSwiftBic(1, false);
                    return {
                        bankEMEAIBAN: isIBANValid && data.bankEMEAIBAN !== "",
                        bankAccountNumber: (data.bankAccountNumber !== "" && (!(ibanExtracted) || extractedIBANParts.bankAccountNumber === data.bankAccountNumber)),
                        bankEMEASortCode: (data.bankEMEASortCode !== "" && (!(ibanExtracted) || (extractedIBANParts.bankId && extractedIBANParts.bankId.toUpperCase() === data.bankEMEASortCode.toUpperCase()))),
                        bankRoutingNumber: (isSwiftValid) ? true : (data.bankRoutingNumber !== "" && isSwiftValid),
                        bankEMEAIntermediarySwift: isImdSwiftValid
                    }
                case "TZA":     
                    if (currentPaymentMethod === 'ACH') {
                        isSwiftValid = this.validateSwiftBic(0, false);
                        isImdSwiftValid = this.validateSwiftBic(1, false);
                        return {
                            bankAccountNumber: (data.bankAccountNumber !== ""),
                            bankEMEASortCode: (data.bankEMEASortCode !== ""),
                            bankEMEAIntermediarySwift: isImdSwiftValid,
                            bankRoutingNumber: (isSwiftValid) ? true : (data.bankRoutingNumber !== "" && isSwiftValid),
                        }
                    }
                    else if (currentPaymentMethod === 'WIR') {
                        isSwiftValid = this.validateSwiftBic(0, true);
                        isImdSwiftValid = this.validateSwiftBic(1, false);
                        return {
                            bankAccountNumber: (data.bankAccountNumber !== "" && (!(ibanExtracted) || extractedIBANParts.bankAccountNumber === data.bankAccountNumber)),
                            bankRoutingNumber: (isSwiftValid) ? true : (data.bankRoutingNumber !== "" && isSwiftValid),
                            bankEMEAIntermediarySwift: isImdSwiftValid
                        }
                    }
                    else {
                        return {
                            bankAccountNumber: false,
                        }
                    }
                case "UGA":                 
                    if (currentPaymentMethod === 'ACH') {
                        isSwiftValid = this.validateSwiftBic(0, false);
                        isImdSwiftValid = this.validateSwiftBic(1, false);
                        return {
                            bankAccountNumber: (data.bankAccountNumber !== ""),
                            bankEMEASortCode: (data.bankEMEASortCode !== ""),
                            bankEMEAIntermediarySwift: isImdSwiftValid,
                            bankRoutingNumber: (isSwiftValid) ? true : (data.bankRoutingNumber !== "" && isSwiftValid),
                        }
                    }
                    else if (currentPaymentMethod === 'WIR') {
                        isSwiftValid = this.validateSwiftBic(0, true);
                        isImdSwiftValid = this.validateSwiftBic(1, false);
                        return {
                            bankAccountNumber: (data.bankAccountNumber !== ""),
                            bankRoutingNumber: (isSwiftValid) ? true : (data.bankRoutingNumber !== "" && isSwiftValid),
                            bankEMEAIntermediarySwift: isImdSwiftValid,
                        }
                    }
                    else {
                        return {
                            bankAccountNumber: false,
                        }
                    }
                default:
                    //Get latest status of IBAN
                    isIBANValid = this.validateIBAN(isCountryIBANEnabled);
                    isSwiftValid = this.validateSwiftBic(0, true);
                    isImdSwiftValid = this.validateSwiftBic(1, false);
                    var isAccountNumberValid = false;
                    var isSortCodeReq = isCountryIBANEnabled;
                    var isBranchIdReq = (bankCountry.countryIBANValidation && bankCountry.countryIBANValidation.ibanBranchIdPos > 0 && bankCountry.countryIBANValidation.ibanBranchIdLen > 0);
                    //DE1000918 - Account Number is required for all other countries.  IBAN is required if on the IBAN ref. Table
                    //Check Account Number if Populated
                    if (data.bankAccountNumber !== "") {
                        //Both Populated
                        if (data.bankEMEAIBAN) {
                            isAccountNumberValid = (isIBANValid && (!(ibanExtracted) ||extractedIBANParts.bankAccountNumber === data.bankAccountNumber));
                        }
                        else {
                            //Only Bank Account
                            isAccountNumberValid = (!(ibanExtracted) || extractedIBANParts.bankAccountNumber === data.bankAccountNumber);
                        }
                    }
                    var isSortCodeValid = false;
                    //Validate Sort code
                    if (isSortCodeReq && data.bankEMEASortCode !== "")
                    {
                        //Required and populated
                        isSortCodeValid = (ibanExtracted && extractedIBANParts.bankId && extractedIBANParts.bankId.toUpperCase() === data.bankEMEASortCode.toUpperCase());
                    }
                    else if (data.bankEMEASortCode === "") {
                        //Field is empty , fails if required
                        isSortCodeValid = !isSortCodeReq;
                    }
                    else {
                        //Not required, but populated
                        isSortCodeValid = (!(ibanExtracted) || (extractedIBANParts.bankId && extractedIBANParts.bankId.toUpperCase() === data.bankEMEASortCode.toUpperCase()));
                    }

                    //Validate Branch ID
                    var isBranchIDValid = false;

                    if (isBranchIdReq && data.bankEMEABranchId !== "") {
                        //Required and populated
                        isBranchIDValid = (ibanExtracted && extractedIBANParts.branchId === data.bankEMEABranchId);
                    }
                    else if (data.bankEMEABranchId === "") {
                        //Field is empty , fails if required
                        isBranchIDValid = !isBranchIdReq;
                    }
                    else {
                        //Not required, but populated
                        if (extractedIBANParts.branchId === "") {
                            //No validation - all any value
                            isBranchIDValid = true;
                        }
                        else {
                            isBranchIDValid = (!(ibanExtracted) || extractedIBANParts.branchId === data.bankEMEABranchId);
                        }
                    }


                    return {
                        bankEMEAIBAN: (isIBANValid),
                        bankAccountNumber: isAccountNumberValid,
                        bankRoutingNumber: (isSwiftValid) ? true : (data.bankRoutingNumber !== "" && isSwiftValid),
                        bankEMEASortCode: isSortCodeValid,
                        bankEMEABranchId: isBranchIDValid,
                        bankEMEAIntermediarySwift: isImdSwiftValid
                    }
            }
        }
        else {
            return {
                bankCountry: false,
               // bankRoutingNumber: data.bankRoutingNumber !== "",
               // bankAccountNumber: data.bankAccountNumber !== "",
               /// bankEMEAIBAN: (data.bankEMEAIBAN) ? ibantools.validateIBAN(data.bankEMEAIBAN).valid : true,
                //bankEMEASortCode: data.bankEMEASortCode
            }

        }
    }

    _validationErrors(val) {
        const errMsgs = {
            emailValMsg: val.emailVal ? '' : 'A valid email is required'
        }
        return errMsgs;
    }
    _grabUserInput() {
        try {
            return {

                bankRoutingNumber: (this.refs.bankRoutingNumber)?this.refs.bankRoutingNumber.value:"",
                bankAccountNumber: (this.refs.bankAccountNumber)?this.refs.bankAccountNumber.value:"",
                bankEMEAIBAN: (this.refs.bankEMEAIBAN) ? this.refs.bankEMEAIBAN.value : "",
                bankEMEASortCode: (this.refs.bankEMEASortCode) ? this.refs.bankEMEASortCode.value : "",
                bankEMEAIntermediarySwift: (this.refs.bankEMEAIntermediarySwift) ? this.refs.bankEMEAIntermediarySwift.value:"",
                bankEMEABranchId: (this.refs.bankEMEABranchId) ? this.refs.bankEMEABranchId.value:"",
                bankCountry: this.state.bankCountry,
                countryList: this.state.countryList
            };
        } catch (e) {
            console.log(`Error validating bank data Ex: ${e}`);
            return {};
        }
    }

    isValidated() {
        const userInput = this._grabUserInput(); // grab user entered vals
        const validateNewInput = this._validateData(userInput); // run the new input against the validator
        let isDataValid = false;
        

        // if full validation passes then save to store and pass as valid
        if (Object.keys(validateNewInput).every((k) => { return validateNewInput[k] === true }))
            {
            if (this.props.getStore().bankAccountNumber !== userInput.bankAccountNumber
                || this.props.getStore().bankRoutingNumber !== userInput.bankRoutingNumber
                || this.props.getStore().bankEMEAIBAN !== userInput.bankEMEAIBAN
                || this.props.getStore().bankEMEASortCode !== userInput.bankEMEASortCode
                || this.props.getStore().bankEMEAIntermediarySwift !== userInput.bankEMEAIntermediarySwift
                || this.props.getStore().bankEMEABranchId !== userInput.bankEMEABranchId
                || this.props.getStore().bankCountry !== userInput.bankCountry
                || this.props.getStore().countryList.length !== this.state.countryList.length) { // only update store of something changed
                this.props.updateStore({
                    ...userInput,
                    savedToCloud: false // use this to notify step4 that some changes took place and prompt the user to save again
                });  // Update store here (this is just an example, in reality you will do it via redux or flux)

            }
            this.setState({
                isFormValid: true,
                hasValidated: true,
                validatedElements: validateNewInput
            });
            isDataValid = true;
        }
        else {
         
            let isInvalid = (this.state.isIBANInvalid) || (this.state.isSwiftInvalid) || (this.state.isInterSwiftInvalid);
            this.setState({
                isFormValid: isDataValid,
                isValidated: ((!isInvalid) && (isDataValid)) ,
                hasValidated: true, 
                validatedElements: validateNewInput
            });
        }
        return isDataValid;
    }

    validationCheck() {
        if (!this._validateOnDemand)
            return;

        const userInput = this._grabUserInput(); // grab user entered vals
        const validateNewInput = this._validateData(userInput); // run the new input against the validator

        this.setState(Object.assign(userInput, validateNewInput, this._validationErrors(validateNewInput)));
    }
    validateSwiftBic(swiftType,isRequired) {
        //0 = DFI Number, 1 = Intermediary Swift, 2 = Biller Code
        //determine which value to use
        var bankRoutingNumber = (this.refs.bankRoutingNumber) ? this.refs.bankRoutingNumber.value.trim() : "";
        var bankImdSwiftNumber = (this.refs.bankEMEAIntermediarySwift) ? this.refs.bankEMEAIntermediarySwift.value.trim() : "";
        var currentSwift = (swiftType === 0 || swiftType === 2) ? bankRoutingNumber : (swiftType === 1) ? bankImdSwiftNumber : "";

        //Handle non-required fields Empty fields
        if (currentSwift === "" && !(isRequired)) {
            if (swiftType === 1) {
                this.setState({
                    isInterSwiftInvalid: false,
                    hasValidated:false
                });
                return true;
            }
            else {
                this.setState({
                    isSwiftInvalid: false,
                    hasValidated: false
                });
                return true;
            }
        }
        else {
            //Either there is a value or it is required
            var swiftValidation = ibantools.validateBIC(currentSwift);

            //Imd Swift does not need to validate against the bank country
            if (swiftType === 1) {
                this.setState({
                    isInterSwiftInvalid: !(swiftValidation.valid),
                    hasValidated: !(swiftValidation.valid)
                });
                return swiftValidation.valid;
            }
            else if (swiftType === 2) {
                // Billing Codes - Valid as long as populated
                this.setState({
                    isSwiftInvalid: (currentSwift===""),
                    hasValidated: (currentSwift === ""),
                });
                return true;
            }
            else if (swiftValidation.valid && this.state.bankCountry.country) {
                //Swift Code
              //  var ibanParts = CommonUtils.extractIBANFields(this.state.bankEMEAIBAN, this.state.bankCountry.countryIBANValidation);//ibantools.extractIBAN(this.state.bankEMEAIBAN);
                var swiftCountry = currentSwift.substring(4,6).toUpperCase(); //JUST NEED COUNTRY ibantools.extractBIC(currentSwift);
                console.log(`Swift Country is ${swiftCountry}`);
                //Check if IBAN and Swift bank identifiers match
                //NOT LONGER NEED var bankIDsMatch = (ibanParts.bankIdentifier === swiftParts.bankIdentifier);
                this.setState({
                    isSwiftInvalid: (!(this.state.bankCountry.countryCode === swiftCountry)),//|| !(bankIDsMatch),
                    hasValidated: !(this.state.bankCountry.countryCode === swiftCountry)
                });
                return (this.state.bankCountry.countryCode === swiftCountry);  //&& (bankIDsMatch)
            }
            else {
                //Swift is not valid
                this.setState({
                    isSwiftInvalid: true
                });
                return false;
            }

        }
    }
    validateAccountNumber() {
     
        let bankAcct = (this.refs.bankAccountNumber) ? this.refs.bankAccountNumber.value : '';
        console.log(`Validating Bank Account ${bankAcct}`)
        this.setState({
            bankAccountNumber: bankAcct,
            isValidated: false
        });
    }
    validateIBAN(isRequired) {
        //Not required and empty - It is valid
        if (!this.refs.bankEMEAIBAN || (!isRequired && (this.refs.bankEMEAIBAN && this.refs.bankEMEAIBAN.value === ""))) {
            this.setState({
                isIBANInvalid: false,
                hasValidated: false,
                ibanExtracted: false,
                extractedIBANParts: {}
            });
            return true;
        }
        else {
            //Perform validation
            var userIBAN = (this.refs.bankEMEAIBAN)?this.refs.bankEMEAIBAN.value.trim().toUpperCase():"";
            var ibanValidation = ibantools.validateIBAN(userIBAN);
  
            if (ibanValidation.valid && this.state.bankCountry.country) {
             
                //USE PSFT Extraction var ibanParts = ibantools.extractIBAN(userIBAN);
                var ibanParts = CommonUtils.extractIBANFields(userIBAN, this.state.bankCountry.countryIBANValidation);
                var psftCheck = CommonUtils.validateIBAN(userIBAN);
                console.log(`Bank Country: ${this.state.bankCountry.country}  Bank Country Code: ${this.state.bankCountry.countryCode}  IBAN Country: ${(ibanParts.countryCode) ? ibanParts.countryCode:""}`);
                //Perform Country Specific handling of IBAN
                var sortCode = '';
                var bankAccount = '';
                switch (this.state.bankCountry.countryCode) {
                    case "IE":
                        sortCode = (ibanParts && this.state.bankCountry.countryCode === ibanParts.countryCode) ?  ibanParts.bankId: '';   //userIBAN.substring(8, 14)
                        bankAccount = (ibanParts && this.state.bankCountry.countryCode === ibanParts.countryCode) ?  ibanParts.bankAccountNumber: '';  //userIBAN.substring(14)
                        this.setState({
                            isIBANInvalid: !((ibanParts && this.state.bankCountry.countryCode === ibanParts.countryCode) && psftCheck),
                            bankEMEASortCode: sortCode,
                            bankAccountNumber: bankAccount,
                            bankEMEAIBAN: userIBAN,
                            hasValidated: !(ibanParts && this.state.bankCountry.countryCode === ibanParts.countryCode),
                            extractedIBANParts: (ibanParts) ? ibanParts : {},
                            ibanExtracted:true
                        });
                        break;
                    default:
                        //Check if Swift is valid
                        if (this.refs.bankRoutingNumber.value && this.refs.bankRoutingNumber.value !== "") {
                            this.validateSwiftBic(0, true);
                        }
           
                       //Do no Extract for other countries
                        //sortCode = (this.state.bankCountry.countryCode === ibanParts.countryCode) ? (ibanParts.branchIdentifier) ? ibanParts.branchIdentifier : ibanParts.sortCode : '';
                        //bankAccount = (this.state.bankCountry.countryCode === ibanParts.countryCode) ? (ibanParts.accountNumber) ? ibanParts.accountNumber : ibanParts.bban : this.refs.bankAccountNumber.value;
                        this.setState({
                            isIBANInvalid:(this.state.bankCountry.countryCode !== ibanParts.countryCode || psftCheck===false),
                            bankEMEAIBAN: userIBAN,
                            // bankEMEASortCode: sortCode,
                            // bankAccountNumber: bankAccount,
                            hasValidated: (this.state.bankCountry.countryCode === ibanParts.countryCode && psftCheck),
                            extractedIBANParts: ibanParts,
                            ibanExtracted: true
                        });
                        break;
                }
               
                return ((this.state.bankCountry.countryCode === ibanParts.countryCode) && psftCheck);
            }
            else {
                //IBAN not valid but populated
                this.setState({
                    isIBANInvalid: true, 
                    bankEMEASortCode: (this.state.bankCountry.countryCode === "IE") ? '' : this.state.bankEMEASortCode,  //DE981493  DE1000918 only impact IE.
                    bankAccountNumber: (this.state.bankCountry.countryCode === "IE") ? '' : this.state.bankAccountNumber,  //DE981493 DE1000918 only impact IE.
                    bankEMEAIBAN: userIBAN,
                    ibanExtracted: false,
                    extractedIBANParts: {}
                });
                return false;
            }
        }
    }
    validateSortCode() {
    }
    trimIBAN() {
        //No Hypens or Spaces
        var iban = this.refs.bankEMEAIBAN.value.replace(this.regExFilter, '');
        this.refs.bankEMEAIBAN.value = iban;        
    }

    trimSwiftBic() { 
        var swift = this.refs.bankRoutingNumber.value.replace(this.regExFilter, '');
        this.refs.bankRoutingNumber.value = swift;
        
    }
    trimAccountNumber() {
        //No Hypens or Spaces
        var acctNum = this.refs.bankAccountNumber.value.replace(this.regExFilter, '');
        //this.refs.bankAccountNumber.value = acctNum;   
        this.setState({
            bankAccountNumber: acctNum,
        });
    }
    trimSortCode(e) {
        //No Hypens or Spaces
        var sortCode = this.refs.bankEMEASortCode.value.replace(this.regExFilter, '');
        this.refs.bankEMEASortCode.value = sortCode;       
        this.setState({
            bankEMEASortCode: sortCode,
        });
    }
    trimIntermediarySwift() {
        //No Hypens or Spaces
        var interSwiftCode = this.refs.bankEMEAIntermediarySwift.value.replace(this.regExFilter, '');
        this.refs.bankEMEAIntermediarySwift.value = interSwiftCode;
    }
    trimBranchId() {
        //No Hypens or Spaces - DE981453: Only Numbers
        var branchId = this.refs.bankEMEABranchId.value.replace(/[^0-9]/g, '');
        this.refs.bankEMEABranchId.value = branchId;
        this.setState({
            bankEMEABranchId: branchId,
        });
    }

    onCountryDDClick() {
        this.setState({ isCountryDDOpen: !this.state.isCountryDDOpen });
    }
    resetForm() {  
        if (this.refs.bankEMEASortCode) {
            this.refs.bankEMEASortCode.value = '';
        }
        if (this.refs.bankEMEAIBAN) {
            this.refs.bankEMEAIBAN.value = '';
        }
        if (this.refs.bankRoutingNumber) {
            this.refs.bankRoutingNumber.value = '';
        }   
        if (this.refs.bankAccountNumber) {
            this.refs.bankAccountNumber.value = '';
        }
        if (this.refs.bankEMEAIntermediarySwift) {
            this.refs.bankEMEAIntermediarySwift.value = '';
        }
        if (this.refs.bankEMEABranchId) {
            this.refs.bankEMEABranchId.value = '';
        }
    }
    getCountries(countryValue) {
        if (countryValue) {
            console.log(`In getCountries with a value of ${countryValue} - getVendorCountries`);
            ServiceCalls.getVendorCountries().then(function (data) {
                if (data) {
                    if (countryValue) {
                        data.sort(function (a, b) { return (a.description > b.description ? 1 : (a.description === b.description ? 0 : -1)) });
                        var selectedCountry = data.find(c => c.country === countryValue);
                        selectedCountry = (selectedCountry) ? selectedCountry : '';
                        console.log(`In EMEA getCountries with a value of ${selectedCountry.country} - ${selectedCountry.description}`);
                        this.setState(
                            {
                                isLoading: false,
                                countryList: data,
                                countriesFetched: true,
                                countrySelected: true,
                                bankCountry: selectedCountry,
                                isCountryIBANEnabled: (selectedCountry.countryIBANValidation && selectedCountry.countryIBANValidation.ibanEnterable === "Y")
                            }
                        );
                    }
                    else {
                        this.setState(
                            {
                                isLoading: false,
                                countryList: data,
                                countriesFetched: true
                            }
                        );
                    }
                    // this.renderForm();
                }
                else {
                    console.log(`Error fetching EMEA Vendor Countries.`);
                    this.setState({ isLoading: false, });
                }
            }.bind(this));
        }
        else {
            console.log(`In getCountries no value to lookup`);
        }
    }
    onCountryNameChange = (event) => {      
        console.log(`In onCountryNameChange with a value of ${event.target.value} `);
        //Do not perform render if bank has not changed
        if (event.target.value !== this.state.bankCountry) {
            var selectedCountry = this.state.countryList.find(c => c.country === event.target.value);
            selectedCountry = (selectedCountry) ? selectedCountry : '';
            var emeaBankDisplay = this.buildEMEABankForm(selectedCountry);
            this.resetForm();
            this.setState({
                bankCountry: selectedCountry,
                emeaBankDisplay: emeaBankDisplay,
                bankName:'',
                bankRoutingNumber: '',    //SWIFT CODE        
                bankAccountNumber: '',
                bankEMEAIBAN: '',
                bankEMEASortCode: '',
                bankEMEAIntermediarySwift: '',
                isValidated: false,
                hasValidated: false,
                isIBANInvalid: false,
                isSwiftInvalid: false,              
                isInterSwiftInvalid: false,
                isFormValid: true,
                isCountryIBANEnabled: (selectedCountry.countryIBANValidation && selectedCountry.countryIBANValidation.ibanEnterable === "Y"),
                extractedIBANParts: {
                    countryCode: null,
                    ibanCheckDigit: null,
                    bankAccountNumber: null,
                    bankId: null,
                    branchId: null,
                    checkDigit: null,
                    dfiIdNumber: null
                },
                ibanExtracted: false,
                validatedElements: {},
            });
        }        
    }

    buildEMEACountryFormControl(country) {   
        const { countryList } = this.state;
        console.log(`EMEA Building display for ${country.country}`);
        var selectedCountry = country;
        if (!country.country && countryList.length > 0) {
            selectedCountry = this.state.countryList.find(c => c.country ===country);
        }

        //DE997225 - Disable element if DFI Qualifier = 'BP'
        //var isDisabled = (this.props.currentBank.dfiQualifier === 'BP');
        //US8945970 Do Not Allow Bank Country Change
        var isDisabled = true;
        var countryInput = (countryList.length > 0)
            ? (selectedCountry)
                ? < Form.Select
                    className="no-arrow-when-disabled"
                    disabled={false}
                    defaultValue={selectedCountry.country}
                    onChange={this.onCountryNameChange}
                    disabled={isDisabled}
                    tabIndex="1"
                    ref="bankCountry">
       {/*             <option key="0">Bank Country</option>*/}
                    {
                        this.state.countryList.map(st => (
                            <option key={st.country} value={st.country}>{st.description} [{st.country}]</option>
                        ))
                    }
                </Form.Select>
                : < Form.Select
                    className="no-arrow-when-disabled"
                    disabled={false}
                    placeholder="Country 2"
                    disabled={isDisabled}
                    defaultValue={selectedCountry.country}
                    onChange={this.onCountryNameChange}
                    tabIndex="1"
                    ref="bankCountry">
                 {/*   <option key="0">Bank Country</option>*/}
                    {
                        this.state.countryList.map(st => (
                            <option key={st.country} value={st.country}>{st.description} [{st.country}]</option>
                        ))
                    }
                </Form.Select>
            : <Form.Control
                ref="bankCountry"
                type="text"
                required
                disabled={isDisabled}
                defaultValue={selectedCountry.country}
                onBlur={this.validationCheck}
                maxLength="3"
                placeholder="Bank Country"
                tabIndex="1"
            />;

        return (<Form.Group as={Col} sm={6} controlId="bankCountry">
            <Form.Label>
                Bank Country
                <span className="required">*</span>
            </Form.Label>
            {countryInput}
        </Form.Group>);
    }
    buildEMEAIBANFormControl(country) {
        const { bankEMEAIBAN, isIBANInvalid, bankAccountNumber, hasValidated, isFormValid, isCountryIBANEnabled } = this.state;
        var renderControl = true;
        var isRequired = true;
        var isValid = true;
        //Check if Country uses IBAN
        if (!isCountryIBANEnabled) {
            return (<Form.Group as={Col} sm={6}>
                    <span>&nbsp;</span>
                    </Form.Group>
                    );
        }

        switch (country.country) {
            case "AUS":
                renderControl = false;
                isRequired = false;
                break;
            case "GBR":
             //UK
                renderControl = true;
                isRequired = false;
                break;
            case "IRL":
                renderControl = true;
                isRequired = true;
                break;
            case "TZA":
                renderControl = false;
                isRequired = false;
                break;
            case "UGA":
                renderControl = false;
                isRequired = false;
                break;        
            default:
                renderControl = true;
                isValid = (!hasValidated)
                    ? true
                    : (isFormValid && hasValidated)
                        ? true
                        : (isCountryIBANEnabled && bankEMEAIBAN === "")
                            ? false
                            : true;
                isRequired = isCountryIBANEnabled; // (!this.refs.bankEMEAIBAN || this.refs.bankEMEAIBAN.value ==="");
                break;        
        }

        return ((renderControl)
            ? <Form.Group as={Col} sm={6} controlId="bankEMEAIBAN">
              {(isRequired)
                ? <Form.Label>IBAN
                    <span className="required">*</span>
                    <OverlayTrigger
                            overlay={<Tooltip>Up to 34 characters, no hyphens or spaces.</Tooltip>}>
                        <span>
                            <FontAwesomeIcon id="fa-rtHelper" size="xs" className="fa-regular bankRequestHelpText" icon={faQuestion} />
                        </span>
                    </OverlayTrigger>
                </Form.Label>
                : <Form.Label>IBAN
                    <OverlayTrigger
                            overlay={<Tooltip>Up to 34 characters, no hyphens or spaces.</Tooltip>}>
                        <span>
                            <FontAwesomeIcon id="fa-rtHelper" size="xs" className="fa-regular bankRequestHelpText" icon={faQuestion} />
                        </span>
                    </OverlayTrigger>
                </Form.Label>
            }
            <Form.Control
                ref="bankEMEAIBAN"
                type="text"
                defaultValue={bankEMEAIBAN}
                onChange={this.trimIBAN}
                    onBlur={()=>this.validateIBAN(isRequired)}
                    isInvalid={isIBANInvalid}
                readOnly={false}
                required={isRequired}
                maxLength="34"
                placeholder="IBAN"
                tabIndex="2"
                autoFocus={true}
                />
                <Form.Control.Feedback type="invalid">
                    IBAN is not valid
                </Form.Control.Feedback>
            </Form.Group>
            : <Form.Group as={Col} sm={6}>
                <span>&nbsp;</span>
            </Form.Group>);
    }
    buildEMEAAccountNumberFormControl(country) {      
        const { bankAccountNumber, isFormValid, hasValidated, bankEMEAIBAN, validatedElements, isCountryIBANEnabled } = this.state;
        const { currentBank, vendorData } = this.props;
        var isRequired = true;
        var isReadOnly = false;
        const currentPaymentMethod = (vendorData.vendorPayments.length > 0) ? vendorData.vendorPayments[0].paymentMethod : '';

        var isValid = (!hasValidated)
            ? true
            : (isFormValid)
                ? true
                : validatedElements.bankAccountNumber;
        //DE994294
        var helperTextDisplay = <OverlayTrigger overlay={<Tooltip>Up to 35 characters, no hyphens or spaces.</Tooltip>}>
                                    <span>
                                        <FontAwesomeIcon id="fa-rtHelper" size="xs" className="fa-regular bankRequestHelpText" icon={faQuestion} />
                                    </span>
                                </OverlayTrigger>; 

        switch (country.country) {
            case "AUS":             
                isRequired = true;
                break;
            case "GBR":
            //UK
                isRequired = true;
                break;
            case "IRL":               
                isRequired = true;//DE981493
                isReadOnly = true;
                helperTextDisplay = <></>;//DE994294
                break;
            case "TZA":              
                isRequired = true;
                break;
            case "UGA":              
                isRequired = true;
                break;
            default:
               
                isValid = (!hasValidated)
                    ? true
                    : (isFormValid)
                        ? true
                        : validatedElements.bankAccountNumber;
              

                //US7935140 - If IBAN is not available - require Account Number
                //1-3-25 Always require
                isRequired = true; //(!isCountryIBANEnabled)?true:!isValid; // (!this.refs.bankEMEAIBAN || this.refs.bankEMEAIBAN.value ==="");
                break;
        }
        const elementLabelName =  CommonUtils.determineVendorBankNumberLabel(country.country, currentPaymentMethod, currentBank.dfiQualifier) ;

        return (<Form.Group as={Col} sm={6} controlId="bankAccountNumber">
            {(isRequired)
                ? <Form.Label>{elementLabelName}
                    <span className="required">*</span>
                    {helperTextDisplay}                    
                </Form.Label>
                : <Form.Label>{elementLabelName}
                    {helperTextDisplay} 
                </Form.Label>               
            }
           
            <Form.Control
                ref="bankAccountNumber"
                type="text"
                value={bankAccountNumber}
                onChange={this.trimAccountNumber}
                onBlur={this.validateAccountNumber}
                readOnly={isReadOnly}
                className={(isReadOnly) ? "disabledControl" : "form-control"}
                required={isRequired}
                maxLength="35"
                placeholder={elementLabelName}
                tabIndex="3"
                isInvalid={!(isValid)}
            />
            <Form.Control.Feedback type="invalid">
                {elementLabelName} is not valid
            </Form.Control.Feedback>
        </Form.Group>);
    }
    buildEMEASortCodeFormControl(country) {
        const { vendorData } = this.props;
        const { bankEMEASortCode, hasValidated, bankEMEAIBAN, validatedElements, isCountryIBANEnabled } = this.state;
        const currentPaymentMethod = (vendorData.vendorPayments.length > 0) ? vendorData.vendorPayments[0].paymentMethod : '';
        console.log(`Building SORT for ${country.country} = Value:${bankEMEASortCode}`);
        var isRequired = true;
        var renderControl = true;        
        var isReadOnly = false;
        var fieldLength = 20; 
        var isInvalid = false;
        var helperText = "Up to 20 characters, no hyphens or spaces.";
        var inValidMessage = `${CommonUtils.determineEMEABankIDLabel(country.country)} is not valid`;  //changed after PSFT IBAN implementation
        
        switch (country.country) {
            case "AUS":
                renderControl = (currentPaymentMethod === 'ACH');
                isRequired = (currentPaymentMethod === 'ACH');
                helperText = (currentPaymentMethod === 'ACH') ? "First 3-digits of BSB number, no hyphens or spaces." : ""
                fieldLength = (currentPaymentMethod === 'ACH') ? 3 : 0;
                isInvalid = (currentPaymentMethod === 'ACH') ? (hasValidated) ? (bankEMEASortCode.length !== 3 || (validatedElements.bankEMEASortCode==="false")) : false : false;
               // inValidMessage = `${CommonUtils.determineEMEABankIDLabel(country.country)} is not valid`;
                break;
            case "GBR":
                //UK
                var ibanValue = (this.refs.bankEMEAIBAN) ? this.refs.bankEMEAIBAN.value : bankEMEAIBAN;
                isRequired = (currentPaymentMethod === 'ACH' || (currentPaymentMethod === 'WIR' && ibanValue !==''));
                isInvalid = (hasValidated && isRequired) ? (bankEMEASortCode === "" || (typeof validatedElements.bankEMEASortCode !== 'undefined' && validatedElements.bankEMEASortCode === false)) : false;
                break;
            case "IRL":
                isRequired = true;  //DE981493
                isReadOnly = true;
                isInvalid = (hasValidated) ? (bankEMEAIBAN === "" || (typeof validatedElements.bankEMEASortCode !== 'undefined' && validatedElements.bankEMEASortCode===false)) : false;
                helperTextDisplay = <></>;//DE994294
                break;
            case "TZA":
                renderControl = (currentPaymentMethod === 'ACH');
                isRequired = (currentPaymentMethod === 'ACH');
                isInvalid = (hasValidated && isRequired) ? (bankEMEASortCode === "" || (typeof validatedElements.bankEMEASortCode !== 'undefined' && validatedElements.bankEMEASortCode === false)) : false;
                break;
            case "UGA":
                renderControl = (currentPaymentMethod === 'ACH');
                isRequired = (currentPaymentMethod === 'ACH');
                isInvalid = (hasValidated && isRequired) ? (bankEMEASortCode === "" || (typeof validatedElements.bankEMEASortCode !== 'undefined' && validatedElements.bankEMEASortCode === false)) : false;
                break;
            default:
                isRequired = isCountryIBANEnabled;
                renderControl = true;
                isInvalid = (hasValidated && isRequired) ? (bankEMEASortCode === "" || (typeof validatedElements.bankEMEASortCode !== 'undefined' && validatedElements.bankEMEASortCode === false)) : false;
                break;
        }
        //DE994294
        var helperTextDisplay = <OverlayTrigger overlay={<Tooltip>{helperText}</Tooltip>}>
            <span>
                <FontAwesomeIcon id="fa-rtHelper" size="xs" className="fa-regular bankRequestHelpText" icon={faQuestion} />
            </span>
        </OverlayTrigger>;
        return (
            (renderControl)
                ? <Form.Group as={Col} sm={6} controlId="bankEMEASortCode">
                    {(isRequired)
                        ? <Form.Label>{CommonUtils.determineEMEABankIDLabel(country.country)}
                            <span className="required">*</span>
                            {helperTextDisplay}
                        </Form.Label>
                        : <Form.Label>{CommonUtils.determineEMEABankIDLabel(country.country)}
                            {helperTextDisplay}
                        </Form.Label>
                    }
                    <Form.Control
                        ref="bankEMEASortCode"
                        type="text"
                        value={bankEMEASortCode}
                        onChange={this.trimSortCode}
                        isInvalid={isInvalid}
                        readOnly={isReadOnly}
                        className={(isReadOnly) ? "disabledControl" :"form-control"}
                        required={ isRequired}
                        maxLength={fieldLength}
                        placeholder={CommonUtils.determineEMEABankIDLabel(country.country)}
                        tabIndex="4"
                    />
                    <Form.Control.Feedback type="invalid">
                        { inValidMessage}
                    </Form.Control.Feedback>
                </Form.Group>
                : <Form.Group as={Col} sm={6}>
                    <span>&nbsp;</span>
                </Form.Group>
        );
        
    }
    buildEMEASwiftCodeFormControl(country) {
        const { currentBank, vendorData } = this.props;
        const { isSwiftInvalid, bankRoutingNumber } = this.state;
        const currentPaymentMethod = (vendorData.vendorPayments.length > 0) ? vendorData.vendorPayments[0].paymentMethod : '';
       
        var isRequired = true;
        var routerValidationCode = 0;
        var maxLength = 11;
        var helperText = "Must be 8 or 11 characters, no hyphens or spaces.";
        var showAUSMsg = false;
    
        switch (country.country) {
            case "AUS":
                //IF Payment Method is ACH, Show Branch ID field
                if (currentPaymentMethod === 'ACH') {
                    return this.buildEMEABranchIdFormControl(country);
                }
                isRequired = (currentPaymentMethod === 'WIR');
                maxLength = (currentBank.dfiQualifier === 'BP' && currentPaymentMethod === 'WIR')
                    ? "12" //Biller Code
                    :"11" //Swift;
                helperText = (currentBank.dfiQualifier === 'BP' && currentPaymentMethod === 'WIR')
                    ? "Up to 12 characters, no hyphens or spaces."
                    : "Must be 8 or 11 characters, no hyphens or spaces.";
                showAUSMsg = (currentBank.dfiQualifier === 'BP' && currentPaymentMethod === 'WIR');
                routerValidationCode = (currentBank.dfiQualifier === 'BP' && currentPaymentMethod === 'WIR')?2:0;
                break;
            case "GBR":
                //UK
                //Swift is required if WIR or ACH and IBAN is entered
                isRequired = (currentPaymentMethod === 'WIR') || (currentPaymentMethod === 'ACH' && (this.refs.bankEMEAIBAN && this.refs.bankEMEAIBAN.value));
                break;
            case "IRL":
                isRequired = true;
                break;
            case "TZA":
                isRequired = (currentPaymentMethod === 'WIR');
                break;
            case "UGA":
                isRequired = (currentPaymentMethod === 'WIR');
                break;
            default:
                isRequired = true;
                break;
        }

        const elementLabel = CommonUtils.determineEMEAVendorBankRoutingLabel(country.country, currentPaymentMethod, currentBank.dfiQualifier);
        return (
     
                <Form.Group as={Col} sm={6} controlId="bankRoutingNumber">
                    {(isRequired)
                    ? <Form.Label>{elementLabel}
                            <span className="required">*</span>
                            <OverlayTrigger
                                overlay={<Tooltip>{helperText}</Tooltip>}>
                                <span>
                                    <FontAwesomeIcon id="fa-rtHelper" size="xs" className="fa-regular bankRequestHelpText" icon={faQuestion} />
                                </span>
                            </OverlayTrigger>
                        </Form.Label>
                    : <Form.Label>{elementLabel}
                            <OverlayTrigger
                                overlay={<Tooltip>{helperText}</Tooltip>}>
                                <span>
                                    <FontAwesomeIcon id="fa-rtHelper" size="xs" className="fa-regular bankRequestHelpText" icon={faQuestion} />
                                </span>
                            </OverlayTrigger>
                        </Form.Label>}

                <Form.Control
                    ref="bankRoutingNumber"
                        type="text"
                        defaultValue={bankRoutingNumber}
                        onChange={this.trimSwiftBic}
                        isInvalid={
                        (this.state.hasValidated && this.state.validatedElements && this.state.validatedElements.bankRoutingNumber === false)
                        || isSwiftInvalid}
                    onBlur={() => this.validateSwiftBic(routerValidationCode, isRequired)}//0 = DFI Number, 1 = Intermediary Swift, 2 = Biller Code
                        readOnly={false}
                        required={isRequired}
                        maxLength={maxLength}
                    placeholder={elementLabel}
                        tabIndex="3"
                />
                <Form.Control.Feedback type="invalid">
                    {elementLabel} is not valid
                </Form.Control.Feedback>
                {(showAUSMsg) ? <div>If you need to change from BPAY Australia, please reach out via the <Link to='/inbox' className='navLinks' onMouseDown={(event) => this.redirectToInbox(event)}>Contact Us</Link> page for assistance.</div> : <></>}
                </Form.Group>);
        

    }
    redirectToInbox = (event) => {
        event.preventDefault();

        console.log('redirecting');
        window.location = '/Inbox';
    }
    buildEMEAImdSwiftCodeFormControl(country) {
        const { currentBank,vendorData } = this.props;
        const { bankEMEAIntermediarySwift, isInterSwiftInvalid } = this.state;
        const currentPaymentMethod = (vendorData.vendorPayments.length > 0) ? vendorData.vendorPayments[0].paymentMethod : '';

        var renderControl = true;

        switch (country.country) {
            case "AUS":
                renderControl = ((currentPaymentMethod === 'WIR' && currentBank.dfiQualifier !== 'BP') || currentPaymentMethod === 'ACH');
                break;
         
            default:              
                renderControl = true;
                break;
        }
        return (
            (renderControl)
                ? <Form.Group as={Col} sm={6} controlId="bankEMEAIntermediarySwift">
                    <Form.Label>Intermediary Swift
                        <OverlayTrigger
                            overlay={<Tooltip>Must be 8 or 11 characters, no hyphens or spaces.</Tooltip>}>
                            <span>
                                <FontAwesomeIcon id="fa-rtHelper" size="xs" className="fa-regular bankRequestHelpText" icon={faQuestion} />
                            </span>
                        </OverlayTrigger>
                    </Form.Label>
                  
            <Form.Control
                ref="bankEMEAIntermediarySwift"
                type="text"
                defaultValue={bankEMEAIntermediarySwift}
                onChange={this.trimIntermediarySwift}
                onBlur={() => this.validateSwiftBic(1,false)}  //0 = DFI Number, 1 = Intermediary Swift
                maxLength="11"
                isInvalid={isInterSwiftInvalid}
                placeholder="Intermediary Swift"
                tabIndex="4"
                    />
                    <Form.Control.Feedback type="invalid">
                       Intermediary Swift is not valid
                    </Form.Control.Feedback>
                </Form.Group>
                : <Form.Group as={Col} sm={6} controlId="bankEMEAIntermediarySwift">
                    <span>&nbsp;</span>
                </Form.Group>
        );

    }
    buildEMEABranchIdFormControl(country) {
        const { bankEMEABranchId, hasValidated, bankCountry, validatedElements } = this.state;
        const { vendorData } = this.props;
        const currentPaymentMethod = (vendorData.vendorPayments.length > 0) ? vendorData.vendorPayments[0].paymentMethod : '';
        var renderControl = false;
        var fieldLength = 10;
        var isInvalid = false;

        var isRequired = false;
        var helperText = "Up to 10-digit number, no hyphens or spaces.";
        var errClass = "noticeText";
        if (this.refs.bankEMEAIBAN && this.refs.bankAccountNumber && hasValidated) {
            errClass = (this.refs.bankEMEAIBAN.value !== "" || this.refs.bankAccountNumber.value !== "") ? "noticeText" : "error noticeText";
        }

        switch (country.country) {
            case "AUS":
                renderControl = (currentPaymentMethod === 'ACH');
                helperText = (currentPaymentMethod === 'ACH') ? "Last 3-digits of BSB number, no hyphens or spaces." : ""
                fieldLength = (currentPaymentMethod === 'ACH') ? 3 : 0;
                isRequired = (currentPaymentMethod === 'ACH');
                isInvalid = (currentPaymentMethod === 'ACH') ? (hasValidated) ? (bankEMEABranchId.length !== 3 || !(validatedElements.bankEMEABranchId)) : false : false;
                break;
            case "IND":
                //DE1134191 For India, Branch ID is NOT required and no asterisk
                renderControl = true;
                isRequired = false;
                break;
            case "GBR":
                //UK
                renderControl = false;
                break;
            case "IRL":
                renderControl = false;
                break;
            case "TZA":
                renderControl = false;
                break;
            case "UGA":
                renderControl = false;
                break;
            default:
                isRequired = (bankCountry.countryIBANValidation && bankCountry.countryIBANValidation.ibanBranchIdPos > 0 && bankCountry.countryIBANValidation.ibanBranchIdLen > 0);
                renderControl = true;
                isInvalid = (hasValidated && isRequired)
                    ? (bankEMEABranchId === "" || (typeof validatedElements.bankEMEABranchId !== 'undefined' && validatedElements.bankEMEABranchId === false))
                    : (hasValidated && bankEMEABranchId !== "") ? (typeof validatedElements.bankEMEABranchId !== 'undefined' && validatedElements.bankEMEABranchId === false):false;

                break;
        }

        var inputGroup = (renderControl)
            ? <Form.Group as={Col} sm={6} controlId="bankEMEABranchId">
                {(isRequired)
                    ? <Form.Label>Branch ID
                        <span className="required">*</span>
                        <OverlayTrigger
                            overlay={<Tooltip>{helperText}</Tooltip>}>
                            <span>
                                <FontAwesomeIcon id="fa-rtHelper" size="xs" className="fa-regular bankRequestHelpText" icon={faQuestion} />
                            </span>
                        </OverlayTrigger>
                    </Form.Label>
                    : <Form.Label>Branch ID
                        <OverlayTrigger
                            overlay={<Tooltip>{helperText}</Tooltip>}>
                            <span>
                                <FontAwesomeIcon id="fa-rtHelper" size="xs" className="fa-regular bankRequestHelpText" icon={faQuestion} />
                            </span>
                        </OverlayTrigger>
                    </Form.Label >}
                <Form.Control
                    ref="bankEMEABranchId"
                    type="text"
                    defaultValue={bankEMEABranchId}
                    onChange={this.trimBranchId}
                    isInvalid={isInvalid}
                    maxLength={fieldLength}
                    required={isRequired}
                    placeholder="Branch ID"
                    tabIndex="3"
                />
                <Form.Control.Feedback type="invalid">
                    Branch ID is not valid
                </Form.Control.Feedback>
            </Form.Group>
            : <Row className="eftStepRow">
                <Form.Group as={Col} sm={12}>
                    <div>&nbsp;</div>
                </Form.Group>
            </Row>;

        //US7935140 - Only show IBAN required message if country is IBAN enabled
        //1-3-25 - Defect Account Number is required for other country template
        //var requiredIBANMessage = (isCountryIBANEnabled)
        //    ? <Form.Group as={Col} sm={6}>
        //        <div className={errClass}>IBAN or Account Number is required.</div>
        //    </Form.Group>
        //    : <Form.Group as={Col} sm={6}>
        //        &nbsp;
        //    </Form.Group>;
        return (
            (country.country === "AUS")
                ? [ inputGroup ]
                : (renderControl)
                    ? <Row className="eftStepRow">
                        {[inputGroup]}
                        <Form.Group as={Col} sm={6}>
                            &nbsp;
                        </Form.Group>
                        </Row>
                    : <></>
        );

    }
  

    buildEMEABankForm(country) {
        const { editMode, currentBank, vendorData } = this.props;
        const { hasValidated, isValidated, isCountryIBANEnabled } = this.state;
        //DE1127877 Missing Message When Bank Country = AUS
        let showAUSMsg = false;
        const currentPaymentMethod = (vendorData.vendorPayments.length > 0) ? vendorData.vendorPayments[0].paymentMethod : '';
        if (country.country === "AUS") {
            showAUSMsg = (currentBank.dfiQualifier === 'BP' && currentPaymentMethod === 'WIR');
        }
       
        var countryInput = this.buildEMEACountryFormControl(country);
        var ibanInput = this.buildEMEAIBANFormControl(country);
        var accountNumberInput = this.buildEMEAAccountNumberFormControl(country);
        var sortCodeInput = this.buildEMEASortCodeFormControl(country);
        var swiftCodeInput = this.buildEMEASwiftCodeFormControl(country);
        var imdSwiftCodeInput = this.buildEMEAImdSwiftCodeFormControl(country);
        var branchIdCodeInput = (country.country==="AUS")?<></>:this.buildEMEABranchIdFormControl(country);

        return (<div className="formSection">
            <Row className="eftStepRow">
                {countryInput}
                {ibanInput}
            </Row>
            <Row className="eftStepRow">
                {accountNumberInput}
                {sortCodeInput}
            </Row>

            <Row className="eftStepRow">
                {swiftCodeInput}
                {imdSwiftCodeInput}
            </Row>
            {branchIdCodeInput} 
            {/*US8945970 Note for EMEA+ Update Bank requests except Aus*/ }
            {!showAUSMsg &&(
                <Row>
                    <Col sm={12}>
                        <Form.Control as="div" plaintext readOnly>
                            If you need to change bank country, please reach out via the <Link href='/Inbox' className='navLinks' onMouseDown={(event) => this.redirectToInbox(event)}>Contact Us</Link> page for assistance.
                        </Form.Control>
                    </Col>
                </Row>
            )}
            <Row className="formBottomRow">
                <Col sm={12}>
                    {(!hasValidated) ? <></> : (this.state.isFormValid && hasValidated) ? <></> : <div className="error" sm={5}>Please enter valid value(s) or reach out via the Contact Us page for assistance.</div>}
                </Col>
            </Row>         
        </div>);

    }

    render() {
        const { editMode, currentBank, vendorData } = this.props;
        const { isLoading, bankCountry } = this.state;
        var stepTitle = "Request Bank Change";
     
        const emeaBankForm = (bankCountry) ? this.buildEMEABankForm(bankCountry) : [];
        var currentPaymentMethod = vendorData.vendorPayments.length > 0 ? vendorData.vendorPayments[0].paymentMethod : '';
        var removeDisplay =
            <>
                <Col sm={6}>

                    <div>
                        <strong>Remove:</strong>
                    </div>

                    <div>
                        <div className="bankDataHdr">Bank Country</div>
                        <div>{currentBank.country}</div>
                    </div>
                    <div>
                        <div className="bankDataHdr">{CommonUtils.determineVendorBankNumberLabel(currentBank.country, currentPaymentMethod, currentBank.dfiQualifier)}</div>
                        <div>{currentBank.bankAccountNumber}</div>
                    </div>
                    {(currentBank.dfiNumber)
                        ? <div>
                            <div className="bankDataHdr">
                                {CommonUtils.determineEMEAVendorBankRoutingLabel(currentBank.country, currentPaymentMethod, currentBank.dfiQualifier)}
                            </div>
                            <div>
                                {currentBank.dfiNumber}
                            </div>
                        </div>
                        : <></>
                    }
                    {(currentBank.ibanId)
                        ? <div>
                            <div className="bankDataHdr">
                                IBAN
                            </div>
                            <div>
                                {`${CommonUtils.maskBankString(currentBank.ibanId)}`}
                            </div>
                        </div>
                        : <></>
                    }
                </Col>
                <Col sm={6}>

                    <div>&nbsp;</div>

                    {
                        (currentBank.bankCode)
                            ? (currentBank.country === "AUS")
                                ? <div>
                                    <div className="bankDataHdr">
                                        BSB
                                    </div>
                                    <div>
                                        {`${currentBank.bankCode} ${currentBank.branchId}`}
                                    </div>
                                </div>
                                : <div>
                                    <div className="bankDataHdr">
                                        {CommonUtils.determineEMEABankIDLabel(currentBank.country)}
                                    </div>
                                    <div>
                                        {currentBank.bankCode}
                                    </div>
                                </div>
                            : <></>
                    }
                    {
                        (currentBank.intermediarySwiftId)
                            ? <div>
                                <div className="bankDataHdr">
                                    Intermediary Swift
                                </div>
                                <div>
                                    {currentBank.intermediarySwiftId}
                                </div>
                            </div>
                            : <></>
                    }
                    {
                        (currentBank.country !== "AUS" && currentBank.branchId)
                            ? <div>
                                <div className="bankDataHdr">
                                    Branch ID
                                </div>
                                <div>
                                    {currentBank.branchId}
                                </div>
                            </div>
                            : <></>
                    }
                </Col>
            </>;
        return (
            <div className="eftStep">
                {
                    (isLoading)
                        ? <div className="loadingForm"><h5> Loading Form ...</h5><br /><Loading /></div>
                        : <Form id="bankForm" noValidate validated={this.state.isValidated} className="form-horizontal">
                            <Row className="eftStepHdrRow">
                                <Col sm={12} className="eftStepHdrText">
                                    {stepTitle}
                                </Col>
                            </Row>
                            <Row className="emeaRemoveArea">
                                {removeDisplay}
                            </Row>
                            {(editMode === "UPDATE")
                                ? <Row>
                                    <Col sm={12}>
                                        <strong>Replace:</strong>
                                    </Col>
                                </Row>
                                : <></>}
                            <Row className="eftStepHdrRow">
                                <Col sm={12} className="eftStepHdrText">
                                    Beneficiary Bank
                                </Col>
                            </Row>
                            {emeaBankForm}    
                        </Form>
                }
            </div>
        )
    }
}
export class StepSignatory extends Component {
    constructor(props) {
        super(props);
        var isEMEASupplier = CommonUtils.determineIfVendorIsEMEAPlus(this.props.vendorData);
        this.state = {
            sigLastName: (isEMEASupplier)
                ? (this.props.getStore().sigLastName === "")
                    ? this.props.currentUser.lastName
                    : this.props.getStore().sigLastName
                : (this.props.getStore().bankSignatory === "YES")
                    ? this.props.currentUser.lastName
                    : this.props.getStore().sigLastName,
            sigPhone: this.props.getStore().sigPhone,
            sigFirstName: (isEMEASupplier)
                ? (this.props.getStore().sigFirstName === "")
                    ? this.props.currentUser.firstName
                    : this.props.getStore().sigFirstName
                : (this.props.getStore().bankSignatory === "YES")
                    ? this.props.currentUser.firstName
                    : this.props.getStore().sigFirstName,
            sigEmail: (isEMEASupplier)
                ? (this.props.getStore().sigEmail === "")
                    ? this.props.currentUser.email
                    : this.props.getStore().sigEmail
                : (this.props.getStore().bankSignatory === "YES")
                    ? this.props.currentUser.email
                    : this.props.getStore().sigEmail,
            sigTitle: this.props.getStore().sigTitle,
            contactFirstName: this.props.getStore().contactFirstName,
            contactLastName: this.props.getStore().contactLastName,
            contactEmail: this.props.getStore().contactEmail,
            contactPhone: this.props.getStore().contactPhone,
            contactTitle: this.props.getStore().contactTitle,
            isValidated: false,
            hasValidated: false,
            isContactEmailValid: false,
            isSigEmailValid: false,
            isLoading: true,
            vendorSPUA: '',
            authCheck: props.getStore().authCheck
        };

        this._validateOnDemand = false; // this flag enables onBlur validation as user fills forms
        this.validationCheck = this.validationCheck.bind(this);
        this.isValidated = this.isValidated.bind(this);
        this.onAuthCheck = this.onAuthCheck.bind(this);
    }
    componentDidMount() {
        const { currentCompanyId } = this.props;
        if (this.state.vendorSPUA === '') {
            ServiceCalls.getSupplierAdmin(currentCompanyId).then(function (data) {
                if (data) {
                    this.setState({
                        vendorSPUA: data,
                        isLoading: false,
                    });
                }
                else {
                    console.log(`Error getting SPUA for Supplier ${currentCompanyId} - Forcing Read Only in Banks`);
                    this.setState({
                        vendorSPUA: {},
                        isLoading: false,
                    });
                }
            }.bind(this));
        }
        else {
            console.log(`Bank Sig loaded.  SPUA already fetched.`);
        }
    }
    componentWillUnmount() {
        const userInput = this._grabUserInput();
        this.props.updateStore({
            ...userInput,
            savedToCloud: false // use this to notify step4 that some changes took place and prompt the user to save again
        });
    }

    isValidated() {
        const userInput = this._grabUserInput(); // grab user entered vals
        const validateNewInput = this._validateData(userInput); // run the new input against the validator

        this.setState({
            ...userInput,
            validationResults: validateNewInput,
            isValidated: Object.values(validateNewInput).every(v => v === true),
            isSigEmailValid: validateNewInput.sigEmail,
            isContactEmailValid: validateNewInput.contactEmail,
            hasValidated: true
        });

        // if full validation passes then save to store and pass as valid
        if (Object.keys(validateNewInput).every((k) => { return validateNewInput[k] === true })) {
            console.log('Sig Step is valid');
            if (this.props.getStore().sigLastName !== userInput.sigLastName ||
                this.props.getStore().sigPhone !== userInput.sigPhone ||
               this.props.getStore().sigFirstName !== userInput.sigFirstName ||
                this.props.getStore().sigEmail !== userInput.sigEmail ||
                this.props.getStore().sigTitle !== userInput.sigTitle ||
                this.props.getStore().contactFirstName !== userInput.contactFirstName ||
                this.props.getStore().contactLastName !== userInput.contactLastName ||
                this.props.getStore().contactEmail !== userInput.contactEmail ||
                this.props.getStore().contactPhone !== userInput.contactPhone ||
                this.props.getStore().contactTitle !== userInput.contactTitle ||
                this.props.getStore().authCheck !== userInput.authCheck)
            { // only update store of something changed
                this.props.updateStore({
                    ...userInput,
                    savedToCloud: false
                });
            }

            return true;
        }
        return false;
    }

    handlePhoneInput = (e) => {
        //DE1130482 do not allow alpha characters
        const cleaned = e.target.value.replace(/[a-zA-Z]/g, '');
        e.target.value = cleaned;
        this.validationCheck();
    };


    validationCheck() {
        if (!this._validateOnDemand)
            return;

        const userInput = this._grabUserInput(); // grab user entered vals
        const validateNewInput = this._validateData(userInput); // run the new input against the validator
        this.setState(Object.assign(userInput, validateNewInput, this._validationErrors(validateNewInput)));
    }

    _validateData(data) {
        var isEMEASupplier = CommonUtils.determineIfVendorIsEMEAPlus(this.props.vendorData);
        var sigEmailCheck = (this.props.getStore().bankSignatory === "NO")
            ? !(this.props.currentUser.email.toLowerCase() === data.sigEmail.toLowerCase())
            : true;
        var performEMEAValidation = (isEMEASupplier) ? (data.sigEmail.toLowerCase() !== this.props.currentUser.email) : false;
        sigEmailCheck = (performEMEAValidation)
            ? CommonUtils.validateEmail(data.sigEmail.toLowerCase(), this.state.vendorSPUA.email) && data.sigEmail.trim().length <= 70
            : (this.props.getStore().bankSignatory === "NO" && sigEmailCheck)
                ? CommonUtils.validateEmail(data.sigEmail.toLowerCase(), this.state.vendorSPUA.email) && data.sigEmail.trim().length <= 70
                : sigEmailCheck;

        var isContactEmailValid = (data.contactEmail !== "")
            ? CommonUtils.validateBasicEmail(data.contactEmail.toLowerCase()) && data.contactEmail.trim().length <= 70
            : true;

        // US8797484  Allow only valid Phone Input Fields
        // Phone validation
        const phoneRegex = /^[^a-zA-Z]*$/  //DE1126376 only prevent letters from being entered, all else is allowed
        const isSigPhoneValid = data.sigPhone && phoneRegex.test(data.sigPhone);
        const isContactPhoneValid = (this.props.editMode !== 'CANCEL')
            ? (data.contactPhone === "" || phoneRegex.test(data.contactPhone))
            : true;

        const isContactPhoneOrEmailProvided = (this.props.editMode !== 'CANCEL')
            ? (data.contactPhone.trim() !== "" || data.contactEmail.trim() !== "")
            : true;
        return {
            sigFirstName: data.sigFirstName !== "", // required: anything besides N/A
            sigLastName: data.sigLastName !== "",
            sigPhone: isSigPhoneValid,
            sigEmail: (data.sigEmail !== "" && sigEmailCheck),
            sigTitle: data.sigTitle !== "",
            contactLastName: (this.props.editMode !== 'CANCEL') ? data.contactLastName !== "" : true,
            contactFirstName: (this.props.editMode !== 'CANCEL') ? data.contactFirstName !== "" : true,
            contactEmail: (this.props.editMode !== 'CANCEL') ? isContactEmailValid : true,
            contactPhone: (this.props.editMode !== 'CANCEL') ? isContactPhoneValid : true,
            contactPhoneOrEmail: isContactPhoneOrEmailProvided, 
            authCheck: (this.props.editMode === 'CANCEL') ? (data.authCheck === true) : true
        }
    }

    _validationErrors(val) {
        const errMsgs = {
            emailValMsg: val.emailVal ? '' : 'A valid email is required'
        }
        return errMsgs;
    }

    _grabUserInput() {
        return {
            sigFirstName: this.refs.sigFirstName.value,
            sigLastName: this.refs.sigLastName.value,
            sigPhone: this.refs.sigPhone.value,
            sigEmail: this.refs.sigEmail.value,
            sigTitle: this.refs.sigTitle.value,
            contactLastName: (this.props.editMode !== 'CANCEL') ? this.refs.contactLastName.value : '',
            contactFirstName: (this.props.editMode !== 'CANCEL') ? this.refs.contactFirstName.value : '',
            contactEmail: (this.props.editMode !== 'CANCEL') ? this.refs.contactEmail.value : '',
            contactPhone: (this.props.editMode !== 'CANCEL') ? this.refs.contactPhone.value : '',
            contactTitle: (this.props.editMode !== 'CANCEL') ? this.refs.contactTitle.value : '',
            authCheck: this.state.authCheck
        };
    }

    onAuthCheck(e) {
        this.setState(
            {
                authCheck: !this.state.authCheck,
            }
        );
    }

    render() {
        var hasSigFN = (this.props.getStore().bankSignatory === "YES" && this.state.sigFirstName !== "");
        var hasSigLN = (this.props.getStore().bankSignatory === "YES" && this.state.sigLastName !== "");
        var hasEmail = (this.props.getStore().bankSignatory === "YES" && this.state.sigEmail !== "");
        var contactEmail = (this.refs.contactEmail) ? this.refs.contactEmail.value : "";
        var contactPhone = (this.refs.contactPhone) ? this.refs.contactPhone.value : "";
        var hasContactReqFields = (contactEmail !== "") || (contactPhone !== "");
        var isEMEASupplier = CommonUtils.determineIfVendorIsEMEAPlus(this.props.vendorData);
        var cancelAuthError = (!(this.state.authCheck) && this.state.isValidated && this.props.editMode === 'CANCEL')
            ? <Row className="eftStepRow">
                <Col sm={12} className="error helperText">
                    Must acknowledge the authorization statement
                </Col>
            </Row>
            : <></>;

        var reqFieldClass = (this.state.hasValidated) ? (hasContactReqFields) ? 'noticeText' : 'error noticeText' : 'noticeText';
        console.log(`Render of Contact  Has Contact fields: ${hasContactReqFields} Is validated: ${this.state.isValidated} Contact Phone: ${this.state.isContactEmailValid}  Contact phone: ${contactPhone} Contact email: ${contactEmail} `);
        var labelPrefix = (isEMEASupplier) ? "Authorized Delegate" : "Signatory";
 
        return (
            <div className="eftStep">

                <Form id="signatoryForm" noValidate validated={this.state.isValidated} className="form-horizontal">
                    <Row className="eftStepHdrRow">
                        <Col sm={12} className="eftStepHdrText">
                            {(isEMEASupplier) ? "Authorized Delegate" : "Account Signatory"}
                        </Col>
                    </Row>
                    <div className="formSection topForm">
                        <Row className="eftStepRow">
                            <Form.Group as={Col} sm={6} controlId="sigLastName">
                                <Form.Label>{labelPrefix} Last Name<span className="required">*</span></Form.Label>
                                <Form.Control
                                    ref="sigLastName"
                                    type="text"
                                    required
                                    onBlur={this.validationCheck}
                                    defaultValue={this.state.sigLastName}
                                    readOnly={hasSigLN && (isEMEASupplier === false)}
                                    disabled={hasSigLN && (isEMEASupplier === false)}
                                    autoFocus={(hasEmail === false)}
                                    maxLength="50"
                                    placeholder={`${labelPrefix} Last Name`}
                                    tabIndex={(hasEmail === false) ? "1" : "2"}
                                    isInvalid={this.state.hasValidated && this.state.validationResults && !this.state.validationResults.sigLastName}
                                    isValid={this.state.hasValidated && this.state.validationResults && this.state.validationResults.sigLastName}
                                />
                            </Form.Group>
                            <Form.Group as={Col} sm={6} controlId="sigPhone">
                                <Form.Label>{labelPrefix} Phone<span className="required">*</span></Form.Label>
                                <Form.Control
                                    ref="sigPhone"
                                    type="text"
                                    defaultValue={this.state.sigPhone}
                                    onChange={this.handlePhoneInput}
                                    required
                                    maxLength="15"
                                    placeholder={`${labelPrefix} Phone`}
                                    tabIndex="3"
                                    isInvalid={this.state.hasValidated && !this._validateData(this._grabUserInput()).sigPhone}
                                    isValid={this.state.hasValidated && this.state.validationResults && this._validateData(this._grabUserInput()).sigPhone }
                                />
                                {this.state.hasValidated && this.refs.sigPhone && this.refs.sigPhone.value !== "" && !this._validateData(this._grabUserInput()).sigPhone && (
                                    <Form.Control.Feedback type="invalid">
                                        Enter a valid phone number
                                    </Form.Control.Feedback>
                                )}
                            </Form.Group>
                        </Row>
                        <Row className="eftStepRow">
                            <Form.Group as={Col} sm={6} controlId="sigFirstName">
                                <Form.Label>{labelPrefix} First Name<span className="required">*</span></Form.Label>
                                <Form.Control
                                    ref="sigFirstName"
                                    type="text"
                                    defaultValue={this.state.sigFirstName}
                                    onBlur={this.validationCheck}
                                    readOnly={hasSigFN && (isEMEASupplier === false)}
                                    disabled={hasSigFN && (isEMEASupplier === false)}
                                    required
                                    maxLength="50"
                                    placeholder={`${labelPrefix} First Name`}
                                    tabIndex={(hasEmail === false) ? "1" : "2"}
                                    isInvalid={this.state.hasValidated && this.state.validationResults && !this.state.validationResults.sigFirstName}
                                    isValid={this.state.hasValidated && this.state.validationResults && this.state.validationResults.sigFirstName}
                                />
                            </Form.Group>
                            <Form.Group as={Col} sm={6} controlId="sigEmail">
                                <Form.Label>{labelPrefix} Email<span className="required">*</span></Form.Label>
                                <Form.Control
                                    ref="sigEmail"
                                    type="email"
                                    defaultValue={this.state.sigEmail}
                                    onChange={this.validationCheck}
                                    isInvalid={this.state.hasValidated && this.state.validationResults && !this.state.validationResults.sigEmail && !this.state.isSigEmailValid}
                                    isValid={this.state.hasValidated && this.state.validationResults && this.state.validationResults.sigEmail}
                                    //required
                                    //isInvalid={(this.state.hasValidated && this.state.isSigEmailValid === false)}
                                    readOnly={hasEmail && (isEMEASupplier === false)}
                                    disabled={hasEmail && (isEMEASupplier === false)}
                                    maxLength="70"
                                    placeholder={`${labelPrefix} Email`}
                                    tabIndex="3"
                                    title={this.state.sigEmail}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {(isEMEASupplier) ? "Authorized Delegate" : "Signatory"} email is not valid
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Row>
                        <Row className="eftStepRow">
                            <Form.Group as={Col} sm={6} controlId="sigTitle">
                                <Form.Label>{labelPrefix} Title <span className="required">*</span></Form.Label>
                                <Form.Control
                                    ref="sigTitle"
                                    type="text"
                                    defaultValue={this.state.sigTitle}
                                    onBlur={this.validationCheck}
                                    required
                                    autoFocus={(hasEmail === true)}
                                    tabIndex={(hasEmail === true) ? "2" : "1"}
                                    maxLength="50"
                                    placeholder={`${labelPrefix} Title`}
                                    isInvalid={this.state.hasValidated && this.state.validationResults && !this.state.validationResults.sigTitle}
                                    isValid={this.state.hasValidated && this.state.validationResults && this.state.validationResults.sigTitle}
                                />
                            </Form.Group>
                        </Row>
                        {(this.props.editMode === 'CANCEL')
                            ?
                            <>
                                <Row className="eftStepRow">
                                    <Form.Group as={Col} sm={1} controlId="authCheck">
                                        <Form.Check
                                            id="authCheck"
                                            type="checkbox"
                                            label=""
                                            required
                                            isInvalid={!(this.state.authCheck) && this.state.isValidated}
                                            checked={this.state.authCheck}
                                            onChange={this.onAuthCheck}
                                            tabIndex="4"
                                        />

                                        <Form.Control.Feedback type="invalid" className="helperText">
                                            Must acknowledge the authorization statement
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Col sm={11}>
                                        I acknowledge upon selecting the Submit button, an email will be sent to the signatory notifying them of the requested bank changes.
                                    </Col>
                                </Row>
                                {cancelAuthError}
                            </>
                            : <></>
                        }

                    </div>
                    {(this.props.editMode !== 'CANCEL')
                        ? <>
                            <Row className="eftStepHdrRow">
                                <Col sm={12} className="eftStepHdrText">
                                    UnitedHealth Group Contact
                                </Col>
                            </Row>
                            <div className="formSection">
                                <Row className="eftStepRow">
                                    <Form.Group as={Col} sm={6} controlId="contactLastName">
                                        <Form.Label>Contact Last Name <span className="required">*</span></Form.Label>
                                        <Form.Control
                                            ref="contactLastName"
                                            type="text"
                                            required
                                            onBlur={this.validationCheck}
                                            defaultValue={this.state.contactLastName}
                                            maxLength="50"
                                            placeholder="Contact Last Name"
                                            tabIndex="4"
                                            isInvalid={this.state.hasValidated && this.state.validationResults && !this.state.validationResults.contactLastName}
                                            isValid={this.state.hasValidated && this.state.validationResults && this.state.validationResults.contactLastName}
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} sm={6} controlId="contactPhone">
                                        <Form.Label>Contact Phone</Form.Label>
                                        <Form.Control
                                            ref="contactPhone"
                                            type="text"
                                            defaultValue={this.state.contactPhone}
                                            onChange={this.handlePhoneInput}
                                            onBlur={this.validationCheck}
                                            required={(hasContactReqFields === false)}
                                            maxLength="15"
                                            placeholder="Contact Phone"
                                            tabIndex="5"
                                            isInvalid={
                                                (this.state.hasValidated && this.state.validationResults && !this.state.validationResults.contactPhone) ||
                                                (this.state.hasValidated && this.state.validationResults && !this.state.validationResults.contactPhoneOrEmail)}
                                            isValid={this.state.hasValidated && this.state.validationResults && this.state.validationResults.contactPhone && this.state.validationResults.contactPhoneOrEmail}
                                        />
                                        {this.state.hasValidated && this.refs.contactPhone && this.refs.contactPhone.value !== "" && !this.state.validationResults.contactPhone && (
                                            <Form.Control.Feedback type="invalid">
                                                Enter a valid phone number
                                            </Form.Control.Feedback>
                                        )}
                                    </Form.Group>
                                </Row>
                                <Row className="eftStepRow">
                                    <Form.Group as={Col} sm={6} controlId="contactFirstName">
                                        <Form.Label>Contact First Name <span className="required">*</span></Form.Label>
                                        <Form.Control
                                            ref="contactFirstName"
                                            type="text"
                                            required
                                            defaultValue={this.state.contactFirstName}
                                            onBlur={this.validationCheck}
                                            maxLength="50"
                                            placeholder="Contact First Name"
                                            tabIndex="4"
                                            isInvalid={this.state.hasValidated && this.state.validationResults && !this.state.validationResults.contactFirstName}
                                            isValid={this.state.hasValidated && this.state.validationResults && this.state.validationResults.contactFirstName}
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} sm={6} controlId="contactEmail">
                                        <Form.Label>Contact Email</Form.Label>
                                        <Form.Control
                                            ref="contactEmail"
                                            type="text"
                                            defaultValue={this.state.contactEmail}
                                            onBlur={this.validationCheck}
                                            isInvalid={
                                                (this.state.hasValidated && this.state.validationResults && !this.state.validationResults.contactEmail) ||
                                                (this.state.hasValidated && this.state.validationResults && !this.state.validationResults.contactPhoneOrEmail)
                                            }
                                            isValid={this.state.hasValidated && this.state.validationResults && this.state.validationResults.contactEmail && this.state.validationResults.contactPhoneOrEmail }
                                            required={(hasContactReqFields === false)}
                                            maxLength="70"
                                            placeholder="Contact Email"
                                            tabIndex="5"
                                            title={this.state.contactEmail }
                                        />
                                        {this.state.hasValidated && this.refs.contactEmail && this.refs.contactEmail.value !== "" && !this.state.validationResults.contactEmail && (
                                            <Form.Control.Feedback type="invalid">
                                                UnitedHealth Group Contact email is not valid
                                            </Form.Control.Feedback>
                                        )}
                                    </Form.Group>
                                </Row>
                                <Row className="eftStepRow">
                                    <Form.Group as={Col} sm={6} controlId="contactTitle">
                                        <Form.Label>Contact Title</Form.Label>
                                        <Form.Control
                                            ref="contactTitle"
                                            type="text"
                                            defaultValue={this.state.contactTitle}
                                            isValid={this.state.hasValidated}
                                            isInvalid={false}
                                            onBlur={this.validationCheck}
                                            maxLength="50"
                                            placeholder="Contact Title"
                                            tabIndex="4"
                                        />
                                    </Form.Group>
                                    <Col sm={6} className={reqFieldClass}>Contact Phone or Email is required</Col>
                                </Row>
                            </div>
                        </>
                        : <></>
                    }
                </Form>
            </div>
        )
    }
}
export class StepAttachments extends Component {
    constructor(props) {
        super(props);
        this.fileInputRef = React.createRef();
     
        this.state = {
            attachCheck: props.getStore().attachCheck,
            attachLetter: props.getStore().attachLetter,
            attachFile: props.getStore().attachFile,
            loadedFile: null,
            isValidated: false,
            hasValidFile: false,
            hasFileBeenValidated:false,
            fileNameLength:0,
            authCheck: props.getStore().authCheck,
            isBankSig: (props.getStore().bankSignatory) ? (props.getStore().bankSignatory === "YES") : false,

        };

        this._validateOnDemand = false; // this flag enables onBlur validation as user fills forms
        this.onFileUploadClick = this.onFileUploadClick.bind(this);
        this.validationCheck = this.validationCheck.bind(this);
        this.isValidated = this.isValidated.bind(this);
        this.onAttachTypeCheck = this.onAttachTypeCheck.bind(this);
        this.onAuthCheck = this.onAuthCheck.bind(this);
        this.onFileInputChange = this.onFileInputChange.bind(this);
        this.onFileDrop = this.onFileDrop.bind(this);
        this.onRemoveAttachment = this.onRemoveAttachment.bind(this);
    }
    componentWillUnmount() {
        const userInput = this._grabUserInput();
        this.props.updateStore({
            ...userInput,
            savedToCloud: false // use this to notify step4 that some changes took place and prompt the user to save again
        });
    }


    isValidated() {
        const userInput = this._grabUserInput(); // grab user entered vals
        const validateNewInput = this._validateData(userInput); // run the new input against the validator
        let isDataValid = false;

        // if full validation passes then save to store and pass as valid
        if (Object.keys(validateNewInput).every((k) => { return validateNewInput[k] === true })) {
            if (this.props.getStore().attachCheck !== userInput.attachCheck ||
                this.props.getStore().attachLetter !== userInput.attachLetter ||
                this.props.getStore().attachFile !== userInput.attachFile ||
                this.props.getStore().authCheck !== userInput.authCheck) { // only update store of something changed
                this.props.updateStore({
                    ...userInput,
                    savedToCloud: false // use this to notify step4 that some changes took place and prompt the user to save again
                });  // Update store here (this is just an example, in reality you will do it via redux or flux)
            }

            isDataValid = true;
        }
        else {
            // if anything fails then update the UI validation state but NOT the UI Data State
           /* var form = document.querySelector("#attachAuthForm");*/
            //var isValid = (form.checkValidity();
            this.setState({ isValidated: true });
        }

        return isDataValid;
    }

    validationCheck() {
        if (!this._validateOnDemand)
            return;
        const userInput = this._grabUserInput(); // grab user entered vals
        const validateNewInput = this._validateData(userInput); // run the new input against the validator
        this.setState(Object.assign(userInput, validateNewInput, this._validationErrors(validateNewInput)));
    }

    _validateData(data) {
        return {
            attachLetter: (data.attachLetter === true || data.attachCheck === true || CommonUtils.determineIfVendorIsEMEAPlus(this.props.vendorData)), // required: anything besides N/A
            attachCheck: (data.attachLetter === true || data.attachCheck === true || CommonUtils.determineIfVendorIsEMEAPlus(this.props.vendorData)),
            attachFile: (data.attachFile !== null) && (data.attachFile !== undefined),
            authCheck: (data.authCheck === true)
        }
    }

    _validationErrors(val) {
        const errMsgs = {
        }
        return errMsgs;
    }

    _grabUserInput() {
        return {
            attachCheck: this.state.attachCheck,//this.refs.attachCheck.checked,
            attachLetter: this.state.attachLetter, //this.refs.attachLetter.checked,
            attachFile: this.state.attachFile, //this.refs.attachFile.value
            authCheck: this.state.authCheck
        };
    }

    onAttachTypeCheck = ({ target: { value } }) => {
        this.setState(
            {
                attachLetter: (value === "LETTER"),
                attachCheck: (value === "CHECK"),
            }
        );
    }

    onFileUploadClick() {
        const fileInp = this.fileInputRef.current;
        fileInp.click();
    }
    onFileDrop(files, event) {
        event.preventDefault();
        this.onFileInputChange(event, files);
    }

    onFileInputChange(e, droppedFiles) {
        const files = (droppedFiles) ? droppedFiles : e.target.files;
        var selectedFile = null;
        Array.from(files).forEach(file => {
            selectedFile = file;
        }
        );
        //Validate file per requirements
        var hasValidFile = false;
   
        var maxFileLength = 1000000 * 5;
        //US7579097 - Set max file name length to 50 characters
        var maxFileNameLength = 50;
        var acceptedFileTypes = ['application/pdf', 'application/doc', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'image/jpg', 'image/bmp', 'image/png', 'image/jpeg'];
        if (selectedFile !== null) {
            var fileNameLength = selectedFile.name.length;
            if (selectedFile.size <= maxFileLength) {
                if (acceptedFileTypes.includes(selectedFile.type)) {
                    if (selectedFile.name.length <= maxFileNameLength) {
                        hasValidFile = true;
                    }
                }
            }
            this.setState({
                attachFile: (hasValidFile === true) ? selectedFile : null,
                hasValidFile: hasValidFile,
                fileNameLength: fileNameLength,
                hasFileBeenValidated: true
            });
        }
        else {
            //DE992153 - No file present
            this.setState({
                attachFile: null,
                hasValidFile: false,
                fileNameLength: 0,
                hasFileBeenValidated: true
            });
        }
    }

    onAuthCheck(e) {
        this.setState(
            {
                authCheck: !this.state.authCheck
            }
        );
    }

    onRemoveAttachment() {
        this.setState({
            attachFile: null,
            hasValidFile: false,
            isValidated: false,
            fileNameLength: 0,
            hasFileBeenValidated:false
        });
    }
    render() {
        var fileName = (this.state.attachFile) ? this.state.attachFile.name : (this.state.fileNameLength > 0) ? "" : "NO FILE";
        var isEMEASupplier = CommonUtils.determineIfVendorIsEMEAPlus(this.props.vendorData);
      
        var authText = (isEMEASupplier)
            ? (this.props.getStore().sigEmail && (this.props.currentUser.email.toLowerCase() === this.props.getStore().sigEmail.toLowerCase()))
              ?<p>
                    I hereby attest that the details provided at the time of submission are accurate and correct to the best of my knowledge.
                    I understand that this information will be used solely for the purpose of managing my account and processing payments.
                </p>
              :
                <>
                    <p>
                        I hereby attest that the details provided at the time of submission are accurate and correct to the best of my knowledge.
                        I understand that this information will be used solely for the purpose of managing my account and processing payments.
                    </p>
                    <p>
                        I acknowledge upon selecting the Submit button, an email will be sent to the Authorized Delegate notifying them of the requested bank changes.
                    </p>
                </>
            : (this.state.isBankSig === true)
                ?<>
                     <p>
                        I hereby authorize and request United HealthCare Services, Inc. ("UHS") to initiate credit entries to the account indicated above,
                        and the financial institution named above is authorized to credit such account. I agree to abide by the National Automated Clearing House Association ("NACHA")
                        rules regarding these entries. Pursuant to the NACHA rules, UHS may initiate a reversing entry to recall a duplicate or erroneous entry
                        that they previously initiated. I understand that, if a reversal action is required, UHS will notify our organization of the error and the
                        reason for the reversal.
                    </p>
                    <p>
                        I agree this authorization is to remain in full force and effect until the COMPANY has received written notification from me of its termination
                        at achsupport@uhg.com in such time and manner as to afford the COMPANY a reasonable opportunity to act on it.
                    </p>
                    <p>
                        I agree this bank account applies to all remit addresses on file.  I certify that I am the signatory.
                    </p>
                </>
                :   <p>
                        I acknowledge upon selecting the Submit button, an email will be sent to the signatory notifying them of the requested bank changes.
                    </p>;

        //var btnText = (this.state.isBankSig === true) ?
        //    'I agree to all statements above.'
        //    : 'I acknowledge upon selecting the Submit button, an email will be sent to the signatory notifying them of the requested bank changes.';
        var btnText = 'I agree to all statements above.';
        var fileOptions = (isEMEASupplier)
            ? <Row className="eftStepRow">
                <Col>Must attach Bank Letter or Company Letter verifying the banking information provided.  The letter provided must include company name, physical address, email address, phone number, signed and dated within 90 days.</Col>
            </Row>
            : <>
                <Row className="eftStepRow">
                    <Col>Must select and attach one:</Col>
                </Row>
                <Row className="eftAuthOpt eftStepRow">
                    <Form.Group as={Col} sm={1} controlId="attachCheck">
                        <Form.Check
                            name="attachType"
                            label=""
                            value="CHECK"
                            type="checkbox"
                            id="attachCheck"
                            required={!(this.state.attachLetter || this.state.attachCheck)}
                            isInvalid={(!this.state.attachCheck && !this.state.attachLetter && this.state.isValidated)}
                            onBlur={this.validationCheck}
                            checked={this.state.attachCheck}
                            onChange={this.onAttachTypeCheck}
                        />
                    </Form.Group>
                    <Col sm={2}><strong>Voided Check</strong></Col>
                    <Col sm={9} className="helperText">Deposit ticket not acceptable. Copy of Voided check should match the accounting information i.e. (Depository Bank Name, Depository Bank Address, Bank Transit & Bank Account # should match the information provided on ACH form.) If providing a check, it cannot be a counter check. Your business/name and a check number must be printed on the check. Direct Deposit enrollment forms, statements, online account printouts are not valid as bank representation.</Col>
                </Row>
                <Row className="eftAuthOpt eftStepRow">
                    <Form.Group as={Col} sm={1} controlId="attachLetter">
                        <Form.Check
                            name="attachType"
                            label=""
                            value="LETTER"
                            type="checkbox"
                            id="attachLetter"
                            required={!(this.state.attachLetter || this.state.attachCheck)}
                            isInvalid={(!this.state.attachCheck && !this.state.attachLetter && this.state.isValidated)}
                            onBlur={this.validationCheck}
                            checked={this.state.attachLetter}
                            onChange={this.onAttachTypeCheck}
                        />

                    </Form.Group>
                    <Col sm={2}><strong>Bank Letter</strong></Col>
                    <Col sm={9} className="helperText">A letter from my bank confirming the bank account and routing numbers. The bank letter must be on bank letterhead and include a bank authorizer name, title, physical address, email address, phone number, signed and dated within 90 days.</Col>
                </Row>
                <Row className="eftStepRow">
                    <Col sm={12}>{((!this.state.attachCheck && !this.state.attachLetter) && this.state.isValidated)
                        ? <div className='error'>Must select an attachment type</div>
                        : <></>}
                    </Col>
                </Row>
            </>;

        var topAreaClass = (this.state.isBankSig === true) ? 'formSection' : 'formSection topForm';
        return (
            <>
                <div className="eftStep">
                    <Form id="attachAuthForm" noValidate validated={this.state.isValidated} className="form-horizontal">
                        <div className={topAreaClass} >
                            <Row className="eftStepHdrRow">
                                <Col sm={12} className="eftStepHdrText">
                                    Attachments
                                </Col>
                            </Row>
                            {fileOptions}
                            <Row className="eftStepRow">
                                {(this.state.attachFile)
                                    ? <Form.Group as={Col} sm={12} controlId="attachFile" className="fileAttachmentArea">
                                        <Form.Label>File Attachment <span className="required">*</span></Form.Label>
                                        <div className="eftUploadedFile">
                                            <div className="uploadedFileName">{this.state.attachFile.name}</div>
                                            <div className="right">
                                                <button title="Remove attachment" className="uploadFileImg" onClick={this.onRemoveAttachment}>
                                                    <FontAwesomeIcon id="fa-remove" size="lg" icon={faTrashCan} />
                                                </button>
                                            </div>
                                        </div>
                                    </Form.Group>
                                    : <Form.Group as={Col} sm={12} controlId="attachFile" className="fileAttachmentArea">
                                        <Form.Label>File Attachment <span className="required">*</span>
                                        </Form.Label>
                                        <div className="eftFileUpload">
                                            <input
                                                onChange={this.onFileInputChange}
                                                ref={this.fileInputRef}
                                                type="file"
                                                style={{ display: "none" }}
                                              ///  onBlur={this.validationCheck}
                                            />
                                            <FileDrop
                                                onDrop={this.onFileDrop}
                                                onTargetClick={this.onFileUploadClick}
                                            >
                                                <div className="vCenter">Click to browse for file or drag and drop it here.</div>
                                            </FileDrop>
                                        </div>
                                        <span className="eftDetailText">Uploads are limited to under 5MB in size and file types of documents, JPG, PDF, PNG.  File names must be under 50 characters.</span>
                                        {
                                            (this.state.isValidated && fileName === "NO FILE")
                                                ? <div className='error'>No file uploaded</div>
                                                : (this.state.hasFileBeenValidated && this.state.hasValidFile===false)                                                   
                                                    ? (Number(this.state.fileNameLength) > 50)
                                                        ? <div className='error'>File name must be under 50 characters.</div>
                                                        : <div className='error'>Must attach a valid file. Uploads are limited to under 5MB in size and file types of documents, JPG, PDF, PNG.</div>
                                                : <></>
                                        }
                                    </Form.Group>
                                }
                            </Row>
                        </div>
                        <div className="formSection">
                            <Row className="eftStepHdrRow">
                                <Col sm={12} className="eftStepHdrText">
                                    Authorization
                                </Col>
                            </Row>
                            <Row className="eftAuthOpt">
                                <Col className="helperText">
                                    {authText}
                                </Col>
                            </Row>
                            <Row className="eftAuthOpt">
                                <Form.Group as={Col} sm={1} controlId="authCheck">
                                    <Form.Check
                                        id="authCheck"
                                        type="checkbox"
                                        label=""
                                        required
                                        isInvalid={!(this.state.authCheck) && this.state.isValidated}
                                        checked={this.state.authCheck}
                                        onChange={this.onAuthCheck}
                                    />

                                </Form.Group>
                                <Col sm={5} className="helperText">{btnText}</Col>
                                <Col sm={6}>{(!(this.state.authCheck) && this.state.isValidated) ? <div className="error">Must acknowledge the authorization statement</div> : <></>}</Col>
                            </Row>
                        </div>
                    </Form>

                </div>
            </>
        )
    }

}
export class StepCancel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            authCertify: props.getStore().authCertify,
            isValidated: false,
            bankSignatory: props.getStore().bankSignatory,
            isBankSig: (props.getStore().bankSignatory) ? (props.getStore().bankSignatory === "YES") : false,
            bankSigSet: (props.getStore().bankSignatory),
        };

        this._validateOnDemand = false; // this flag enables onBlur validation as user fills forms

        this.validationCheck = this.validationCheck.bind(this);
        this.isValidated = this.isValidated.bind(this);
        this.onAuthCheck = this.onAuthCheck.bind(this);

    }
    componentWillUnmount() {
        try {
            const userInput = this._grabUserInput();
            this.props.updateStore({
                ...userInput,
                savedToCloud: false // use this to notify step4 that some changes took place and prompt the user to save again
            });
        } catch (e) {
            //quietly handle dismount
        }
    }

    isValidated() {
        const userInput = this._grabUserInput(); // grab user entered vals
        const validateNewInput = this._validateData(userInput); // run the new input against the validator
        let isDataValid = false;

        // if full validation passes then save to store and pass as valid
        if (Object.keys(validateNewInput).every((k) => { return validateNewInput[k] === true })) {
            if (this.props.getStore().authCertify !== userInput.authCertify
                || this.props.getStore().bankSignatory !== userInput.bankSignatory) {
                // only update store of something changed
                this.props.updateStore({
                    ...userInput,
                    savedToCloud: false // use this to notify step4 that some changes took place and prompt the user to save again
                });  // Update store here (this is just an example, in reality you will do it via redux or flux)
            }
            isDataValid = true;
        }
        else {
            // if anything fails then update the UI validation state but NOT the UI Data State
            //this.setState(Object.assign(userInput, validateNewInput, this._validationErrors(validateNewInput)));
            var form = document.querySelector("#cancelForm");
            form.checkValidity();
            this.setState({ isValidated: true });
        }

        return isDataValid;
    }
    validationCheck() {
        if (!this._validateOnDemand)
            return;

        const userInput = this._grabUserInput(); // grab user entered vals
        const validateNewInput = this._validateData(userInput); // run the new input against the validator

        this.setState(Object.assign(userInput, validateNewInput, this._validationErrors(validateNewInput)));
    }
    _validateData(data) {
        const { isBankSig } = this.state;
        if (isBankSig === undefined) {
            return {
                isBankSig: false,
                authCertify: false,
                bankSignatory: ''
            }
        }
        else {
            return {
                isBankSig: (this.state.bankSignatory === "YES" || this.state.bankSignatory === "NO"),
                bankSignatory: this.state.bankSignatory !== '',
                authCertify: ((isBankSig && this.state.authCertify === true) || (!isBankSig))
            }
        }
    }
    onBankSigClick = ({ target: { value } }) => {
        this.setState({
            isBankSig: (value === "YES"),
            bankSigSet: true,
            bankSignatory: value,
            isValidated: false
            // authCheck: (value === "NO")
        });
        console.log(`Cancel Bank Sig changed - Value: ${value}`);
        this.props.onBankSigChange(value);
    }

    _grabUserInput() {
        return {
            authCertify: this.state.authCertify,
            bankSignatory: this.state.bankSignatory
        };
    }

    onAuthCheck(e) {
        this.setState(
            {
                authCertify: !this.state.authCertify
            }
        );
    }

    render() {

        const { currentBank } = this.props;
        return (
            <div className="eftStep">
                <Form id="cancelForm" noValidate validated={this.state.isValidated} className="form-horizontal">
                    <div className="formSection">
                        <Row className="eftStepHdrRow">
                            <Col sm={12} className="eftStepHdrText">
                                Cancellation of ACH Payments
                            </Col>
                        </Row>
                        <Row className="eftStepRow">
                            <Col sm={12}>
                                <strong>Discontinue Electronic Funds Transfers to this bank account.</strong>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={5}>
                                Bank Name:
                            </Col>
                            <Col sm={7}>
                                {currentBank && currentBank.beneficiaryBank && currentBank.beneficiaryBank.trim()}
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={5}>
                                {CommonUtils.determineVendorBankNumberLabel(currentBank.country, "ACH", currentBank.dfiQualifier)}:
                            </Col>
                            <Col sm={7}>
                                {(currentBank.bankAccountNumber)
                                    ? currentBank && currentBank.bankAccountNumber && currentBank.bankAccountNumber.trim()
                                    : ""
                                }
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={5}>
                                {(currentBank.dfiQualifier)
                                    ? `${ CommonUtils.determineVendorBankRoutingLabel(currentBank.dfiQualifier)}:`
                                    : ""
                                }                                
                            </Col>
                            <Col sm={7}>
                                {currentBank && currentBank.dfiNumber && currentBank.dfiNumber.trim()}
                            </Col>
                        </Row>

                        <Row>
                            <Form.Group as={Col} sm={12} className="sigRadios">
                                <Form.Label className="helperText">Are you account signatory or authorized delegate?<span className="required">*</span></Form.Label>
                                <br />
                                <Form.Check
                                    inline={true}
                                    label="Yes"
                                    value="YES"
                                    name="bankSignatory"
                                    onChange={this.onBankSigClick}
                                    required={true}
                                    type="radio"
                                    checked={(this.state.bankSigSet !== '') ? (this.state.isBankSig === true) : false}
                                    id="bankSignatoryYes"
                                    tabIndex="1"
                                />
                                <Form.Check
                                    inline={true}
                                    label="No"
                                    value="NO"
                                    checked={(this.state.bankSigSet !== '') ? (this.state.isBankSig === false) : false}
                                    name="bankSignatory"
                                    required={true}
                                    type="radio"
                                    id="bankSignatoryNo"
                                    onChange={this.onBankSigClick}
                                    tabIndex="1"
                                />
                            </Form.Group>

                        </Row>
                        <Row className="eftStepRow">
                            <Col sm={12}>
                                {((this.state.bankSigSet === '') && this.state.isValidated) ? <div className="error helperText">Must select one.</div> : <></>}
                            </Col>
                        </Row>
                        {(this.state.isBankSig === true) ?
                            <Row className="eftAuthOpt">
                                <Form.Group as={Col} sm={1} controlId="authCertify">
                                    <Form.Check
                                        id="authCertify"
                                        type="checkbox"
                                        tabIndex="2"
                                        label=""
                                        required
                                        isInvalid={!(this.state.authCertify) && this.state.isValidated}
                                        checked={this.state.authCertify}
                                        onChange={this.onAuthCheck}
                                    />

                                </Form.Group>
                                <Col sm={11} className="helperText">By selecting this checkbox, I certify that I am the signatory.</Col>
                            </Row>
                            : <></>}
                        <Row className="eftStepRow">
                            <Col sm={12}>{(!(this.state.authCertify) && this.state.isValidated && this.state.isBankSig === true) ? <div className="error">Must acknowledge the authorization statement</div> : <></>}</Col>
                        </Row>
                    </div>
                </Form>
            </div>
        )
    }
}
export class StepComplete extends Component {
    constructor(props) {
        super(props);
        this.showAlertMessage = this.showAlertMessage.bind(this);
        this.state = {
            submitMsg: this.props.submitOpts.submitMsg,
            submitMsgLvl: this.props.submitOpts.submitMsgLvl,
            isSubmitting: this.props.submitOpts.isSubmitting,
            isSubmitComplete: this.props.submitOpts.isSubmitComplete

        }
    }
    componentDidUpdate(prevProps, prevState) {

        if (JSON.stringify(prevProps.submitOpts) !== JSON.stringify(this.props.submitOpts)) {
           // this.removeCancelBtn();
            this.setState({
                submitMsg: this.props.submitOpts.submitMsg,
                submitMsgLvl: this.props.submitOpts.submitMsgLvl,
                isSubmitting: this.props.submitOpts.isSubmitting,
                isSubmitComplete: this.props.submitOpts.isSubmitComplete
            });
        }
    }

    removeCancelBtn() {
        var cancelBtn = document.querySelector("#eftCancelBtn");
        if (cancelBtn) {
            console.log('Removing cancel button from complete screen');
            cancelBtn.remove();
        }
    }

    showAlertMessage() {
        console.log(`Showing Alert message ${this.state.isSubmitComplete}`);
        if (this.state.isSubmitComplete) {
            return (<TimedDisplay delay="3000" callback={this.props.onRequestSubmit}>
                <Alert variant={this.state.submitMsgLvl}>{this.state.submitMsg}</Alert>
            </TimedDisplay>);
        }
        else {
            return (<></>);
        }
    }

    render() {
        const { isSubmitting, isSubmitComplete, submitMsg } = this.state;
        const stepHeader = (isSubmitting === true) ? "Submitting Request" : (isSubmitComplete) ? "Request Submitted" : "Submitting Request";
        const showLoading = (isSubmitting === true) ? <Loading /> : <></>;
        const stepText = (isSubmitting === true) ? submitMsg : this.showAlertMessage();
        if (isSubmitting) {
            console.log('Submiting form - hinding Cancel')
            this.removeCancelBtn();
        }
        return (
            <div className="eftStep">
                <Row className="eftStepHdr">
                    <Col>
                        <label className="col-md-12 control-label">
                            <h5>{stepHeader}</h5>
                        </label>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {showLoading}
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {stepText}
                    </Col>
                </Row>
            </div>
        )
    }
}
export class VendorBankPopUp extends Component {
    constructor(props) {
        super(props)

        this.resetForm = this.resetForm.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.postSubmit = this.postSubmit.bind(this);
        this.submitAddUpdateRequest = this.submitAddUpdateRequest.bind(this);
        this.submitCancelRequest = this.submitCancelRequest.bind(this);
        this.onCancelBankSigChange = this.onCancelBankSigChange.bind(this);
        this.showPopup = this.showPopup.bind(this);

        this.blankStore = {
            taxIdNumber: '',
            bankName: '',
            bankAddress: '',
            bankRoutingNumber: '',
            bankCity: '',
            bankAccountNumber: '',
            bankState: '',
            bankPostal: '',
            bankCountry: 'USA',
            bankSignatory: '',
            sigLastName: '',
            sigPhone: '',
            sigFirstName: '',
            sigEmail: '',
            sigTitle: '',
            contactLastName: '',
            contactFirstName: '',
            contactTitle: '',
            contactPhone: '',
            contactEmail: '',
            attachCheck: false,
            attachLetter: false,
            attachFile: null,
            authSigned: false,
            authTime: false,
            authAddress: false,
            authCertify: false,
            authCheck: false,
            stateList: [],
            countryList:[],
            bankEMEAIBAN: '',
            bankEMEASortCode: '',
            bankEMEAIntermediarySwift: '',
            bankEMEABranchId: ''

        };
        this.requestStore = {
            taxIdNumber: '',
            bankName: '',
            bankAddress: '',
            bankRoutingNumber: '',
            bankCity: '',
            bankAccountNumber: '',
            bankState: '',
            bankPostal: '',
            bankCountry: 'USA',
            bankSignatory: '',
            sigLastName: '',
            sigPhone: '',
            sigFirstName: '',
            sigEmail: '',
            sigTitle: '',
            contactLastName: '',
            contactFirstName: '',
            contactTitle: '',
            contactPhone: '',
            contactEmail: '',
            attachCheck: false,
            attachLetter: false,
            attachFile: null,
            authCheck: false,
            stateList: [],
            countryList: [],
            bankEMEAIBAN: '',
            bankEMEASortCode: '',
            bankEMEAIntermediarySwift: '',
            bankEMEABranchId:''
        };
        this.state = {
            isLoading: false,
            hasError: false,
            submitMsg: '',
            submitMsgLvl: '',
            isSubmitting: false,
            isPopupOpen: false,
            validated: false,
            isReadOnly: true,
            vendorSPUA: {},
            isSubmitComplete: false,
            ACHWarningPopUpOpen: false,
            hasRecentBankRequest:false
        }
    }

    componentDidMount() {
        window.sessionStorage.setItem("step", "0");
    }

    componentDidUpdate(prevProps, prevState) {
        if ((!window.sessionStorage.getItem("step") || window.sessionStorage.getItem("step") === "0") && this.state.isPopupOpen && !this.state.isLoading) {
            this.addCancelBtn(0);
        }
    }

    getStore() {
        return this.requestStore;
    }
    updateStore(update) {
        this.requestStore = {
            ...this.requestStore,
            ...update,
        }
    }

    handleSubmit() {
        const { editMode } = this.props;
        //VALID
        switch (editMode) {
            case "ADD":
                this.submitAddUpdateRequest();
                break;
            case "CANCEL":
                this.submitCancelRequest();
                break;
            case "UPDATE":
                this.submitAddUpdateRequest();
                break;
            default:
        }
    }

    submitAddUpdateRequest() {
        const { vendorData, editMode } = this.props;
        this.setState({ isSubmitting: true, submitMsg: 'Sending attachment to storage' });
        var requestData = this.getStore();
        var attachInfo = RequestUtils.createAttachmentInfo(requestData, vendorData.vendorRecordId);
        console.log(`Prepping form for a ${editMode.toUpperCase()} request`);
        //Need to file upload first to get storage url
        ServiceCalls.sendFileAttachment(attachInfo).then(function (attachData) {
            //Check if file was successfully save by storage URL.  If so add to request and send.
            if (attachData.isSuccessful && attachData.errorMessage === null) {
                this.setState({ isSubmitting: true, submitMsg: 'Attachment saved.  Submitting request' });
                var bankRequest = (editMode.toUpperCase() === "ADD") ? this.buildAddBankRequest(requestData, attachData) : this.buildUpdateBankRequest(requestData, attachData);

                //MAKE SURE TO SUBMIT ALL VALUES IN CAP LETTERS TO DB
                ServiceCalls.submitBankRequest(bankRequest).then(function (data) {
                    //Validate results                    
                    var errLvl = (data.errorMsg) ? "danger" : "info";
                    var msg = (data.errorMsg) ? `Error Submitting request ${data.errorMsg}` : `Successfully submitted request`;
                    this.setState({
                        isSubmitting: false,
                        submitMsg: msg,
                        submitMsgLvl: errLvl,
                        isSubmitComplete: true
                    });
                }.bind(this));
            }
            else {
                //TODO
                console.log(`Error uploading attachment.  Is Successful: ${attachData.isSuccessful}  Error: ${attachData.errorMessage}`);
                var actionResponse = 'Failed to upload attachment.  Try again';
                var errLvl = 'danger';

                this.setState({
                    isSubmitting: false,
                    submitMsg: actionResponse,
                    submitMsgLvl: errLvl,
                    isSubmitComplete: true
                });
            }
        }.bind(this));
    }
    submitCancelRequest()
     {
        /*const { vendorData } = this.props;*/
        var requestData = this.getStore();
      
        this.setState({ isSubmitting: true, submitMsg: 'Submitting Cancel request to server', isSubmitComplete: false });
        var bankRequest = this.buildCancelBankRequest(requestData);  
        //MAKE SURE TO SUBMIT ALL VALUES IN CAP LETTERS TO DB
        ServiceCalls.submitBankRequest(bankRequest).then(function (data) {
            //Validate results                    
            var errLvl = (data.errorMsg) ? "danger" : "info";
            var msg = (data.errorMsg) ? `Error Submitting request ${data.errorMsg}` : `Successfully submitted request`;
            this.setState({
                isSubmitting: false,
                submitMsg: msg,
                submitMsgLvl: errLvl,
                isSubmitComplete: true
            });
        }.bind(this));
    }

    resetForm() {
        window.sessionStorage.removeItem("step");
        this.setState({
            submitMsg: '',
            isLoading: false,
            submitMsgLvl: '',
            isSubmitting: false,
            hasError: false,
            isPopupOpen: false,
            validated: false,
            ACHWarningPopUpOpen: false,
            hasRecentBankRequest: false
        });
    }

    onCancelClick(e) {
        e.preventDefault();
        this.resetForm();
    }
    postSubmit() {
        this.resetForm();
        this.props.onVendorChange();
    }

    //Lift state to ACHWarning popup component
    cancelACHWarning = (shouldContinue) => {
        if (shouldContinue) {
            this.setState({
                ACHWarningPopUpOpen: false,
            });
        }
        else {
            this.setState({
                ACHWarningPopUpOpen: false,
                isPopupOpen: false
            });
        }
    }
    showPopup(showACHWarning,showApprovedReqWarning) {
        this.setState({
            isPopupOpen: !(showApprovedReqWarning),
            ACHWarningPopUpOpen: showACHWarning,
            showApprovedWarningMessage:showApprovedReqWarning
        });
    }

    openPopup() {
        const { editMode,currentCompanyId } = this.props;
      //  var vendorAddresses = vendorData.vendorAddresses;
        var showACHWarning = false;
        //US6787109 - Fetch latest Vendor Information before displaying Bank Popup to get current count of Addresses.
        //Get the latest Vendor data from Server to make sure a new address or bank request has been added
        //Start with clear form
        this.updateStore(this.blankStore);
        console.log(`Fetching Latest Vendor info for ${currentCompanyId} - Add Bank PopUp`)
        ServiceCalls.getVendorInfo(Number(currentCompanyId)).then(function (results) {
            console.log(`Fetched Latest Vendor info for ${currentCompanyId} - Add Bank PopUp`)
            if (results) {
                var vendorAddresses = results.vendorAddresses;
                var bankRequests = results.requests;               
                showACHWarning = false;
                //Check for recent approved bank request
                var approvedReqs = bankRequests.filter(r => r.requestStatusId === 2);
                //DE865353 check for recent pending requests
                var pendingReqs = bankRequests.filter(r => r.requestStatusId !== 2 && r.requestStatusId !== 5 && r.requestStatusId !== 6 && r.requestStatusId !== 7);
                var hasRecentApprovedReqs = false;
                if (pendingReqs.length > 0) {
                    hasRecentApprovedReqs = true;
                }
                else {                   
                    hasRecentApprovedReqs = approvedReqs.length > 0 ?
                        approvedReqs.filter(function (item) {
                            return CommonUtils.determineIfTimeWithinRange(item.updatedDt, 60);
                        }).length > 0
                        : false;
                }

                if (hasRecentApprovedReqs === true) {
                    this.showPopup(showACHWarning, true);
                }
                //Check if address was recently added
                else if (editMode.trim().toUpperCase() === "ADD" || editMode.trim().toUpperCase() === "UPDATE")
                {
                    //Do not show address warning for EMEA Plus suppliers
                    var isEMEASupplier = CommonUtils.determineIfVendorIsEMEAPlus(this.props.vendorData);
                    if (isEMEASupplier) {
                        this.showPopup(false, false);
                    }
                    else {
                        const activeAddressCount = vendorAddresses.filter(address => address.effStatus === 'A').length;
                        this.showPopup(activeAddressCount > 1, false);
                    }
                }
                else {
                    this.showPopup(showACHWarning,false)
                }
            }
            else {
                console.log(`No vendor info returned for Supplier ${currentCompanyId} - Add Bank PopUp`);
                this.showPopup(showACHWarning)
            }
            
        }.bind(this));
    }
    //Including payment method in bank request
    getCurrentPaymentMethod() {
        const { vendorData } = this.props;
        return (vendorData.vendorPayments && vendorData.vendorPayments.length > 0)
            ? vendorData.vendorPayments[0].paymentMethod
            : '';
    }

    buildAddBankRequest(formData, attachData) {
        const { vendorData, currentUser } = this.props;
        const currentPaymentMethod = this.getCurrentPaymentMethod();
        var request = {
            "BankRequest": {
                "VendorBankRequestId": 0,
                "VendorRecordId": vendorData.vendorRecordId,
                "RequestorContactId": currentUser.contactId,
                "VendorBankId": 0,
                "RequestStatusId": 1,
                "RequestTypeId": 2,
                "BankAddress": formData.bankAddress.replace(/[\n\r]/g, '').toUpperCase(),
                "BankCity": formData.bankCity.replace(/[\n\r]/g, '').toUpperCase(),
                "BankState": (formData.bankState.toUpperCase() === "STATE") ? '' : formData.bankState.toUpperCase(),
                "BankPostal": formData.bankPostal.replace(/[\n\r]/g, '').toUpperCase(),
                "SignatoryFirstName": formData.sigFirstName.replace(/[\n\r]/g, '').toUpperCase(),
                "SignatoryLastName": formData.sigLastName.replace(/[\n\r]/g, '').toUpperCase(),
                "SignatoryPhone": formData.sigPhone.replace(/[\n\r]/g, '').toUpperCase(),
                "SignatoryEmail": formData.sigEmail.replace(/[\n\r]/g, '').toUpperCase(),
                "SignatoryTitle": formData.sigTitle.replace(/[\n\r]/g, '').toUpperCase(),
                "UhgContactFirstName": formData.contactFirstName.replace(/[\n\r]/g, '').toUpperCase(),
                "UhgContactLastName": formData.contactLastName.replace(/[\n\r]/g, '').toUpperCase(),
                "UhgContactPhone": formData.contactPhone.replace(/[\n\r]/g, '').toUpperCase(),
                "UhgContactEmail": formData.contactEmail.replace(/[\n\r]/g, '').toUpperCase(),
                "UhgContactTitle": formData.contactTitle.replace(/[\n\r]/g, '').toUpperCase(),
                "PaymentMethod": currentPaymentMethod,
                "EarlyWarningScore": -1,
                "UpdatedDt": null
            },
            "BankRecord": {
                "VendorBankId": 0,
                "VendorId": vendorData.vendorId,
                "VendorSetId": vendorData.vendorSetId,
                "VendorRecordId": vendorData.vendorRecordId,
                "EffStatus": "P",
                "BeneficiaryBank": formData.bankName.replace(/[\n\r]/g, '').toUpperCase(),
                "DfiQualifier": "01",
                "BankAccountNumber": formData.bankAccountNumber.replace(/[\n\r]/g, '').toUpperCase(),
                "DfiNumber": formData.bankRoutingNumber.replace(/[\n\r]/g, '').toUpperCase(),
                "IbanId": "",
                "TaxIdNumber": formData.taxIdNumber.replace(/[\n\r]/g, '').toUpperCase(),
                "Country": formData.bankCountry.replace(/[\n\r]/g, '').toUpperCase(),
                "BankKey": "",
                "VendorBankRequestId": 0,
                "IsOriginalContent": false
            },
            "RequestAttachments": [
                {
                    "VendorBankRequestId ": 0,
                    "FileName": formData.attachFile.name.toUpperCase(),
                    "FileType": attachData.attachedFile.contentType.toUpperCase(),
                    "AttachmentTypeId": attachData.attachmentType,
                    "FileSize": attachData.attachedFile.length,
                    "StorageUrl": attachData.storageURL,
                    "CreatedDt": new Date(),
                    "SubmitterContactId": currentUser.contactId
                }
            ],
            "VendorRecord": {
                "VendorRecordId": vendorData.vendorRecordId,
                "VendorId": vendorData.vendorId,
                "VendorSetId": vendorData.vendorSetId,
                "Name ": vendorData.name,
                "Status ": "",
                "Persistence ": "",
                "CommodityType ": "",
                "WithholdingType ": "",
                "DefaultClass ": "",
                "TaxIdNumber ": vendorData.taxIdNumber,
                "VendorKey": ""
            },
            "RequestComments": []
        };

        return request;
    }

    buildUpdateBankRequest(formData, attachData) {
        const { vendorData, currentUser } = this.props;
        const currentPaymentMethod = this.getCurrentPaymentMethod();
        var currentBanks = vendorData.vendorBanks.filter(b => b.effStatus === 'A');
        var currentBank = (currentBanks.length > 0) ? currentBanks[0] : {};
        var isEMEASupplier = CommonUtils.determineIfVendorIsEMEAPlus(vendorData);
        var request = {
            "BankRequest": {
                "VendorBankRequestId": 0,
                "VendorRecordId": vendorData.vendorRecordId,
                "RequestorContactId": currentUser.contactId,
                "VendorBankId": 0,
                "RequestStatusId": 1,
                "RequestTypeId": 3,
                "BankAddress": formData.bankAddress.replace(/[\n\r]/g, '').toUpperCase(),
                "BankCity": formData.bankCity.replace(/[\n\r]/g, '').toUpperCase(),
                "BankState": (formData.bankState.toUpperCase() === "STATE") ? '' : formData.bankState.toUpperCase(),
                "BankPostal": formData.bankPostal.replace(/[\n\r]/g, '').toUpperCase(),
                "SignatoryFirstName": formData.sigFirstName.replace(/[\n\r]/g, '').toUpperCase(),
                "SignatoryLastName": formData.sigLastName.replace(/[\n\r]/g, '').toUpperCase(),
                "SignatoryPhone": formData.sigPhone.replace(/[\n\r]/g, '').toUpperCase(),
                "SignatoryEmail": formData.sigEmail.replace(/[\n\r]/g, '').toUpperCase(),
                "SignatoryTitle": formData.sigTitle.replace(/[\n\r]/g, '').toUpperCase(),
                "UhgContactFirstName": formData.contactFirstName.replace(/[\n\r]/g, '').toUpperCase(),
                "UhgContactLastName": formData.contactLastName.replace(/[\n\r]/g, '').toUpperCase(),
                "UhgContactPhone": formData.contactPhone.replace(/[\n\r]/g, '').toUpperCase(),
                "UhgContactEmail": formData.contactEmail.replace(/[\n\r]/g, '').toUpperCase(),
                "UhgContactTitle": formData.contactTitle.replace(/[\n\r]/g, '').toUpperCase(),
                "PaymentMethod": currentPaymentMethod,
                "EarlyWarningScore": -1,
                "UpdatedDt": null
            },
            "BankRecord": {
                "VendorBankId": 0,
                "VendorId": vendorData.vendorId,
                "VendorSetId": vendorData.vendorSetId,
                "VendorRecordId": vendorData.vendorRecordId,
                "EffStatus": 'P',
                "BeneficiaryBank": formData.bankName.replace(/[\n\r]/g, '').toUpperCase(),
                "DfiQualifier": (isEMEASupplier) ? CommonUtils.determineEMEADFIQualifier(formData.bankRoutingNumber.replace(/[\n\r]/g, '').toUpperCase(), currentBank.dfiQualifier) : "01",  //DE992153
                "BankAccountNumber": formData.bankAccountNumber.replace(/[\n\r]/g, '').toUpperCase(),
                "DfiNumber": formData.bankRoutingNumber.replace(/[\n\r]/g, '').toUpperCase(),
                "IbanId": formData.bankEMEAIBAN.replace(/[\n\r]/g, '').toUpperCase(),
                "Country": (formData.bankCountry.country) ? formData.bankCountry.country.toUpperCase() : formData.bankCountry.toUpperCase(),
                "BankCode": formData.bankEMEASortCode.replace(/[\n\r]/g, '').toUpperCase(),
                "BranchId": formData.bankEMEABranchId.replace(/[\n\r]/g, '').toUpperCase(),
                "IntermediarySwiftId": formData.bankEMEAIntermediarySwift.replace(/[\n\r]/g, '').toUpperCase(),
                "BankKey": "",
                "VendorBankRequestId": 0,
                "IsOriginalContent": false
            },
            "RequestAttachments": [
                {
                    "VendorBankRequestId ": 0,
                    "FileName": formData.attachFile.name.toUpperCase(),
                    "FileType": attachData.attachedFile.contentType.toUpperCase(),
                    "AttachmentTypeId": attachData.attachmentType,
                    "FileSize": attachData.attachedFile.length,
                    "StorageUrl": attachData.storageURL,
                    "CreatedDt": new Date(),
                    "SubmitterContactId": currentUser.contactId
                }
            ],
            "VendorRecord": {
                "VendorRecordId": vendorData.vendorRecordId,
                "VendorId": vendorData.vendorId,
                "VendorSetId": vendorData.vendorSetId,
                "Name ": vendorData.name,
                "Status ": "",
                "Persistence ": "",
                "CommodityType ": "",
                "WithholdingType ": "",
                "DefaultClass ": "",
                "TaxIdNumber ": vendorData.taxIdNumber,
                "VendorKey": ""
            },
            "RequestComments": []
        };

        return request;
    }

    buildCancelBankRequest(formData) {
        const { vendorData, currentUser } = this.props;
        // DE784103 - Bank location info was undefined in ACH emails. 
        //Need to reverse requests array to get the last request approved in the case that there is multiple approved requests...
        var reversedRequests = [...vendorData.requests].reverse();
        var bankInfo = reversedRequests.find(request => request.requestStatusId === 2);
        const currentPaymentMethod = this.getCurrentPaymentMethod();

        var currentBank = (vendorData.vendorBanks.length > 0) ? vendorData.vendorBanks[0] : {};
        var request = {
            "BankRequest": {
                "VendorBankRequestId": 0,
                "VendorRecordId": vendorData.vendorRecordId,
                "RequestorContactId": currentUser.contactId,
                "VendorBankId": 0,
                "RequestStatusId": 1,
                "RequestTypeId": 1,
                "BankAddress": (bankInfo === undefined) ? '' : bankInfo.bankAddress,
                "BankCity": (bankInfo === undefined) ? '' : bankInfo.bankCity,
                "BankState": (bankInfo === undefined) ? '' : bankInfo.bankState,
                "BankPostal": (bankInfo === undefined) ? '' : bankInfo.bankPostal,
                "SignatoryFirstName": (formData.bankSignatory === "YES") ? this.props.currentUser.firstName.toUpperCase() : formData.sigFirstName.replace(/[\n\r]/g, '').toUpperCase(),
                "SignatoryLastName": (formData.bankSignatory === "YES") ? this.props.currentUser.lastName.toUpperCase() : formData.sigLastName.replace(/[\n\r]/g, '').toUpperCase(),
                "SignatoryPhone": (formData.bankSignatory === "YES") ? "" : formData.sigPhone.replace(/[\n\r]/g, '').toUpperCase(),//11-3 Blank out if requestor is signatory
                "SignatoryEmail": (formData.bankSignatory === "YES") ? this.props.currentUser.email.toUpperCase() : formData.sigEmail.replace(/[\n\r]/g, '').toUpperCase(),
                "SignatoryTitle": (formData.bankSignatory === "YES") ? "" : formData.sigTitle.replace(/[\n\r]/g, '').toUpperCase(), //11-3 Blank out if requestor is signatory
                "UhgContactFirstName": '',
                "UhgContactLastName": '',
                "UhgContactPhone": '',
                "UhgContactEmail": '',
                "UhgContactTitle": '',
                "PaymentMethod": currentPaymentMethod,
                "EarlyWarningScore": -2,  //12-15 DE816122 Cancel requests do not call EW - Setting default value to -2 so UI conditions can render correctly
                "UpdatedDt": null
            },
            "BankRecord": {
                "VendorBankId": currentBank.vendorBankId,
                "VendorId": vendorData.vendorId,
                "VendorSetId": vendorData.vendorSetId,
                "VendorRecordId": vendorData.vendorRecordId,
                "EffStatus": 'I',
                "BeneficiaryBank": currentBank.beneficiaryBank,
                "DfiQualifier": currentBank.dfiQualifier,
                "BankAccountNumber": currentBank.bankAccountNumber,
                "DfiNumber": currentBank.dfiNumber,
                "IbanId": currentBank.ibanId,
                "Country": (currentBank.country) ? currentBank.country : '',
                "BankKey": currentBank.bankKey,
                "VendorBankRequestId": 0,
                "IsOriginalContent": false
            },
            "RequestAttachments": [

            ],
            "VendorRecord": {
                "VendorRecordId": vendorData.vendorRecordId,
                "VendorId": vendorData.vendorId,
                "VendorSetId": vendorData.vendorSetId,
                "Name ": vendorData.name,
                "Status ": "",
                "Persistence ": "",
                "CommodityType ": "",
                "WithholdingType ": "",
                "DefaultClass ": "",
                "TaxIdNumber ": vendorData.taxIdNumber,
                "VendorKey": ""
            },
            "RequestComments": []
        };

        return request;
    }

    onCancelBankSigChange(isSigValue) {
        var curValues = this.getStore();
        console.log(`Setting Cancel sig to ${isSigValue}`);
        curValues.bankSignatory = isSigValue;
        this.updateStore(curValues);
        console.log(`Cancel sig set to ${isSigValue}`);
        this.setState({ sigSet: isSigValue });
    }

    addCancelBtn(step) {
        if (this.state.isPopupOpen && !this.state.ACHWarningPopUpOpen) {
            const parent = document.querySelector("div.multi-step div.footer-buttons");
            console.log(`Changing Step to ${step}`);
            var cancelCls = (step === 0)
                ? (this.props.editMode.toUpperCase() === "CANCEL")
                    ? "eftCancelStep0Btn"
                    : "eftCancel2Btn"
                : (this.props.editMode.toUpperCase() === "CANCEL")
                    ? "eftCancelStep1Btn"
                    : "eftCancel3Btn";
            if (!parent.querySelector("#eftCancelBtn")) {
                const button = document.createElement("button");
                button.classList.add(...["btn", "btn-primary", cancelCls]);
                button.innerHTML = "Cancel";
                button.id = "eftCancelBtn";
                button.type = "button";
                button.tabIndex = 8;
                button.onclick = this.onCancelClick;
                parent.append(button);
            }
            else {
                //Change class based on step
                console.log("Have existing btn adding class " + cancelCls);
                var cancelBtn = parent.querySelector("#eftCancelBtn");
                cancelBtn.classList.remove(...["eftCancel2Btn", "eftCancel3Btn"]);
                cancelBtn.classList.add(...[cancelCls]);
            }
            //Add Index for NExt and Previos
            var nextBtn = document.querySelector(".eftNextBtn");
            if (nextBtn) {
                nextBtn.tabIndex = 8;
            }

            var prevBtn = document.querySelector(".eftPrevBtn");
            if (prevBtn) {
                prevBtn.tabIndex = 8;
            }
        }


    }
    getButtonName() {
        const { editMode } = this.props;
        switch (editMode.toUpperCase()) {
            case "ADD":
                return "Enroll in ACH";
            case "UPDATE":
                return "Update Bank";
            case "CANCEL":
                return "Cancel ACH";
            default:
                return "";
        }
    }

    render() {
        const { currentCompanyId, editMode } = this.props;
        const { isPopupOpen, isLoading, isSubmitComplete, ACHWarningPopUpOpen, showApprovedWarningMessage } = this.state;
        var currentBank = (this.props.vendorData.vendorBanks.length > 0) ? this.props.vendorData.vendorBanks[0] : {};
        var isEMEASupplier = CommonUtils.determineIfVendorIsEMEAPlus(this.props.vendorData);
        //console.log(`Rendering Main component  Step: ${window.sessionStorage.getItem("step")}  Bank:  ${this.getStore().bankSignatory}  Sig Set: ${sigSet}`);
        const steps = (this.props.editMode.toUpperCase() === "CANCEL")
            ? (this.getStore().bankSignatory === "NO")
                ? [
                    { name: 'Cancel',key:'stepCancel', component: <StepCancel vendorData={this.props.vendorData} getStore={() => (this.getStore())} updateStore={(u) => { this.updateStore(u) }} currentUser={this.props.currentUser} currentBank={currentBank} onBankSigChange={this.onCancelBankSigChange} /> },
                    { name: 'Account Signatory', key: 'stepSignatory', component: <StepSignatory key="stepSignatory" vendorData={this.props.vendorData}  getStore={() => (this.getStore())} updateStore={(u) => { this.updateStore(u) }} currentUser={this.props.currentUser} editMode={this.props.editMode} currentCompanyId={currentCompanyId} /> },
                    { name: 'Complete', key: 'stepComplete', component: <StepComplete key="stepComplete" vendorData={this.props.vendorData} submitOpts={this.state} editMode={this.props.editMode} onRequestSubmit={this.postSubmit} /> }
                ]
                : [
                    { name: 'Cancel', key: 'stepCancel', component: <StepCancel key="stepCancel" vendorData={this.props.vendorData} getStore={() => (this.getStore())} updateStore={(u) => { this.updateStore(u) }} currentUser={this.props.currentUser} currentBank={currentBank} onBankSigChange={this.onCancelBankSigChange} /> },
                    { name: 'Complete', key: 'stepComplete', component: <StepComplete key="stepComplete" vendorData={this.props.vendorData} submitOpts={this.state} editMode={this.props.editMode} onRequestSubmit={this.postSubmit} /> }
                ]
            : (isEMEASupplier)
                ? [
                    { name: 'Beneficiary Bank', key: 'stepEmeaBank', component: <StepEMEABank key="stepEmeaBank" vendorData={this.props.vendorData} editMode={this.props.editMode} currentBank={currentBank} getStore={() => (this.getStore())} updateStore={(u) => { this.updateStore(u) }} /> },
                    { name: 'Account Signatory', key: 'stepSignatory', component: <StepSignatory key="stepSignatory" vendorData={this.props.vendorData}  getStore={() => (this.getStore())} updateStore={(u) => { this.updateStore(u) }} currentUser={this.props.currentUser} editMode={this.props.editMode} currentCompanyId={currentCompanyId} /> },
                    { name: 'Attachments', key: 'stepAttach', component: <StepAttachments key="stepAttachments" vendorData={this.props.vendorData} getStore={() => (this.getStore())} updateStore={(u) => { this.updateStore(u) }} currentUser={this.props.currentUser} /> },
                    // { name: 'Authorization', component: <StepAuthorization getStore={() => (this.getStore())} updateStore={(u) => { this.updateStore(u) }} /> },
                    { name: 'Complete', key: 'stepComplete', component: <StepComplete key="stepComplete" vendorData={this.props.vendorData} submitOpts={this.state} editMode={this.props.editMode} onRequestSubmit={this.postSubmit} /> }
                  ]
                : [
                    { name: 'Depository Bank', key: 'stepBank', component: <StepBank key="stepBank" vendorData={this.props.vendorData} editMode={this.props.editMode} currentBank={currentBank} getStore={() => (this.getStore())} updateStore={(u) => { this.updateStore(u) }} /> },
                    { name: 'Account Signatory', key: 'stepSignatory', component: <StepSignatory key="stepSignatory" vendorData={this.props.vendorData} getStore={() => (this.getStore())} updateStore={(u) => { this.updateStore(u) }} currentUser={this.props.currentUser} editMode={this.props.editMode} currentCompanyId={currentCompanyId} /> },
                    { name: 'Attachments', key: 'stepAttach', component: <StepAttachments key="stepAttachments" vendorData={this.props.vendorData} getStore={() => (this.getStore())} updateStore={(u) => { this.updateStore(u) }} currentUser={this.props.currentUser} /> },
                    // { name: 'Authorization', component: <StepAuthorization getStore={() => (this.getStore())} updateStore={(u) => { this.updateStore(u) }} /> },
                    { name: 'Complete', key: 'stepComplete', component: <StepComplete key="stepComplete" vendorData={this.props.vendorData} submitOpts={this.state} editMode={this.props.editMode} onRequestSubmit={this.postSubmit} /> }
                  ];
        var btnName = this.getButtonName();
        var btnClasses = "vContactBtn right"; // OLD(editMode.toUpperCase() === "ADD") ? "vContactBtn right" : "vContactBtn";
        var popUpClass = (editMode.toUpperCase() === "CANCEL") ? "eftCancelBankArea" : "eftBankEnrollArea";
        return (
            (!isPopupOpen)
                ? (showApprovedWarningMessage === true)
                    ? <div className="approvedBankWarningMsg">Bank account temporarily unavailable for editing</div>
                    :<Button className={btnClasses} onClick={() => this.openPopup()}> { btnName }</Button >
                : (ACHWarningPopUpOpen)
                    ? <ACHWarningPopUp cancelACHWarning={this.cancelACHWarning} />
                    : <Popup open={isPopupOpen} modal closeOnDocumentClick={false} closeOnEscape={true} onClose={this.resetForm}>
                        {close => (isLoading)
                            ? (<Loading />)
                            : (
                                <div className={popUpClass} >
                                    <StepZilla
                                        steps={steps}
                                        preventEnterSubmission={true}
                                        nextTextOnFinalActionStep={"Submit"}
                                        nextButtonCls="eftNextBtn btn btn-primary"
                                        backButtonCls="eftPrevBtn btn btn-primary"
                                        showSteps={false}
                                        dontValidate={false}
                                        prevBtnOnLastStep={false}
                                        startAtStep={0}
                                        onStepChange={step => {
                                            window.sessionStorage.setItem("step", step);
                                            console.log(`On Step# ${step} change for ${editMode.toUpperCase()} process.  Is Sig: ${this.getStore().bankSignatory}  Is complete: ${isSubmitComplete}`);
                                            this.addCancelBtn(step);
                                           
                                            if (editMode.toUpperCase() === "ADD" ||
                                                editMode.toUpperCase() === "UPDATE") {

                                                if (step === 3 && isSubmitComplete) {
                                                }
                                                else if (step === 3) {
                                                    this.handleSubmit();
                                                }
                                                else {
                                                    //Normal ops
                                                    // this.setStep(step);
                                                }
                                            }
                                            else if (editMode.toUpperCase() === "CANCEL") {
                                                if (((step === 2 && this.getStore().bankSignatory === "NO") || (step === 1 && this.getStore().bankSignatory === "YES")) && isSubmitComplete) {
                                                    //Show complete step
                                                    console.log('SHOW COMPLETE');
                                                }
                                                else if ((step === 2 && this.getStore().bankSignatory === "NO") || (step === 1 && this.getStore().bankSignatory === "YES")) {
                                                    console.log('SUBMIT FORM');
                                                    this.handleSubmit();
                                                }
                                                else {
                                                    //Normal ops
                                                    //this.setStep(step);
                                                }
                                            }
                                            else {
                                                console.log('Invalid Edit mode');
                                            }
                                        }}
                                    />
                                </div>

                            )
                        }
                    </Popup>

        );
    }
}
